export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  NaiveDateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AdDimension {
  Banner = 'BANNER',
  Billboard = 'BILLBOARD',
  LargeBanner = 'LARGE_BANNER',
  MediumRectangle = 'MEDIUM_RECTANGLE',
  MyShopiBanner = 'MY_SHOPI_BANNER',
  SplashAppBanner = 'SPLASH_APP_BANNER'
}

export enum AdDisplayAt {
  BlogDetailBottom = 'BLOG_DETAIL_BOTTOM',
  BlogDetailTop = 'BLOG_DETAIL_TOP',
  Brand = 'BRAND',
  BrochureAbove = 'BROCHURE_ABOVE',
  BrochureEndAboveGoogleMaps = 'BROCHURE_END_ABOVE_GOOGLE_MAPS',
  BrochureEndInteresting = 'BROCHURE_END_INTERESTING',
  BrochureEndLeft = 'BROCHURE_END_LEFT',
  BrochureEndRight = 'BROCHURE_END_RIGHT',
  BrochureStart = 'BROCHURE_START',
  BrochureStartBottom = 'BROCHURE_START_BOTTOM',
  BrochureViewerInterface = 'BROCHURE_VIEWER_INTERFACE',
  Categories = 'CATEGORIES',
  Category = 'CATEGORY',
  CategoryAboveBrochures = 'CATEGORY_ABOVE_BROCHURES',
  FavoritesEnd = 'FAVORITES_END',
  HomepageBottom = 'HOMEPAGE_BOTTOM',
  HomepageImpact = 'HOMEPAGE_IMPACT',
  HomepageTop = 'HOMEPAGE_TOP',
  ImpactApp = 'IMPACT_APP',
  NewBrochures = 'NEW_BROCHURES',
  NewBrochuresBottom = 'NEW_BROCHURES_BOTTOM',
  NewBrochuresWeb = 'NEW_BROCHURES_WEB',
  Shop = 'SHOP',
  ShopCard = 'SHOP_CARD',
  Splash = 'SPLASH',
  SplashApp = 'SPLASH_APP'
}

export type AdHtmlContent = {
  adDimension: AdDimension;
  content: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum AdPlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum AdStatusAll {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export enum AdStatusV2 {
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export enum AdTargetType {
  Default = 'DEFAULT',
  Fallback = 'FALLBACK'
}

export enum AdTimeStepEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum AdType {
  HtmlEmbed = 'HTML_EMBED',
  ImageAd = 'IMAGE_AD'
}

export type AdUpload = {
  adDimension: AdDimension;
  file: Scalars['Upload']['input'];
  url: Scalars['String']['input'];
};

export type AdminBrochureReadEntity = {
  __typename?: 'AdminBrochureReadEntity';
  androidReads: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  embedReads: Scalars['Int']['output'];
  iosReads: Scalars['Int']['output'];
  totalReads: Scalars['Int']['output'];
  webReads: Scalars['Int']['output'];
};

export type AdminBrochureReadsInput = {
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  languageIds: Array<InputMaybe<Scalars['ID']['input']>>;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: TimeStepEnum;
};

export type AdminFields = {
  /** The categories for which the brochure can be shown at the end of a brochure after the last page. */
  brochureAfterpage: Array<Scalars['ID']['input']>;
  brochureCategories: Array<Scalars['ID']['input']>;
  /** The categories for which the brochure can be shown as the top of a brochure stack. */
  brochureToplevel: Array<Scalars['ID']['input']>;
  customerLevel: CustomerLevel;
  hotspotMode: HotspotMode;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true then all products in the brochure will be removed from the search. */
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign: Scalars['String']['input'];
  utmMedium: Scalars['String']['input'];
};

export type AdminShopEntity = {
  __typename?: 'AdminShopEntity';
  afterpage: Array<CategoryEntity>;
  autoParserSlugFr?: Maybe<Scalars['String']['output']>;
  autoParserSlugNl?: Maybe<Scalars['String']['output']>;
  autoParserType?: Maybe<AutoParserType>;
  categories: Array<CategoryEntity>;
  customerClient?: Maybe<CustomerClientEntity>;
  customerLevel: CustomerLevel;
  fileUrl?: Maybe<Scalars['String']['output']>;
  geminiTaggingPrompt?: Maybe<Scalars['String']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  lastPage: Scalars['Boolean']['output'];
  localBrochures: Scalars['Boolean']['output'];
  locations: Array<LocationEntity>;
  name: Scalars['String']['output'];
  overwriteUtms: Scalars['Boolean']['output'];
  radius: Scalars['Float']['output'];
  regions: Array<RegionEntity>;
  removedFromSearch: Scalars['Boolean']['output'];
  removedProductsFromSearch: Scalars['Boolean']['output'];
  shopDescriptions: Array<ShopDescriptionEntity>;
  shopKeywords?: Maybe<Scalars['String']['output']>;
  showAds: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  toplevel: Array<CategoryEntity>;
};


export type AdminShopEntityFileUrlArgs = {
  version: ShopFileVersion;
};


export type AdminShopEntityLocationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminShopInput = {
  shopId: Scalars['ID']['input'];
};

export enum AdminShopOrderBy {
  CustomerLevelAsc = 'CUSTOMER_LEVEL_ASC',
  CustomerLevelDesc = 'CUSTOMER_LEVEL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RadiusAsc = 'RADIUS_ASC',
  RadiusDesc = 'RADIUS_DESC'
}

export type AdminShopsInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  hotspotMode?: InputMaybe<HotspotMode>;
  localBrochures?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy: AdminShopOrderBy;
  overwriteUtms?: InputMaybe<Scalars['Boolean']['input']>;
  removedFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search for shop name */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdsAdvertisementEntity = {
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  displayAt: AdDisplayAt;
  /** @deprecated Use displayUrl on AdsAdvertismentImage instead */
  displayUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export type AdsAdvertisementHtmlEmbed = AdsAdvertisementEntity & {
  __typename?: 'AdsAdvertisementHtmlEmbed';
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  content: Scalars['String']['output'];
  displayAt: AdDisplayAt;
  /** @deprecated HtmlEmbed ads will no longer have urls. Remove field from any query. */
  displayUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export type AdsAdvertisementImage = AdsAdvertisementEntity & {
  __typename?: 'AdsAdvertisementImage';
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export enum AdsAdvertisementOrderBy {
  DisplayAtAsc = 'DISPLAY_AT_ASC',
  DisplayAtDesc = 'DISPLAY_AT_DESC',
  ImpressionsLimitAsc = 'IMPRESSIONS_LIMIT_ASC',
  ImpressionsLimitDesc = 'IMPRESSIONS_LIMIT_DESC',
  PlatformTypeAsc = 'PLATFORM_TYPE_ASC',
  PlatformTypeDesc = 'PLATFORM_TYPE_DESC',
  StatusAtAsc = 'STATUS_AT_ASC',
  StatusAtDesc = 'STATUS_AT_DESC',
  WeightAsc = 'WEIGHT_ASC',
  WeightDesc = 'WEIGHT_DESC'
}

export type AdsAdvertisementStatisticsOverviewInput = {
  adsCampaignId: Scalars['ID']['input'];
  /** Stats from the campaign ads from this date */
  startAt: Scalars['Date']['input'];
  /** Stats from the campaign ads until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: AdTimeStepEnum;
};

export type AdsAdvertisementStatisticsOverviewListResponse = {
  __typename?: 'AdsAdvertisementStatisticsOverviewListResponse';
  /** How many times all advertisements combined have been clicked. */
  clicks: Scalars['Int']['output'];
  /** Ad campaign id */
  id: Scalars['ID']['output'];
  /** How many times the advertisements have been seen. */
  impressions: Scalars['Int']['output'];
  /** An overview of statistics per advertisement. */
  statisticsEntries: Array<AdvertisementStatisticsEntryEntity>;
  /** The sum per key-value pair of the statistics_entries. */
  sumStatisticsEntry: AdvertisementStatisticsMapsEntity;
};

export type AdsCampaignAdvertisementInput = {
  id: Scalars['ID']['input'];
};

export type AdsCampaignAdvertisementsInput = {
  adsCampaignId: Scalars['ID']['input'];
  orderBy: AdsAdvertisementOrderBy;
};

export type AdsCampaignCreateFormEntity = {
  __typename?: 'AdsCampaignCreateFormEntity';
  adDimensions: Array<AdDimension>;
  displayAtPositions: Array<AdDisplayAt>;
  selectableCategories: Scalars['Boolean']['output'];
  selectableShops: Scalars['Boolean']['output'];
};

export type AdsCampaignCreateFormInput = {
  displayAtPositions: Array<AdDisplayAt>;
  platforms: Array<AdPlatformType>;
};

export type AdsCampaignEntity = {
  __typename?: 'AdsCampaignEntity';
  customerClient: CustomerClientEntity;
  id: Scalars['ID']['output'];
  languageId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  status: AdsCampaignStatus;
  stopAt: Scalars['DateTime']['output'];
  targetType: AdTargetType;
};

export type AdsCampaignInput = {
  id: Scalars['ID']['input'];
};

export enum AdsCampaignOrderBy {
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StartAtAsc = 'START_AT_ASC',
  StartAtDesc = 'START_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StopAtAsc = 'STOP_AT_ASC',
  StopAtDesc = 'STOP_AT_DESC',
  TargetTypeAsc = 'TARGET_TYPE_ASC',
  TargetTypeDesc = 'TARGET_TYPE_DESC'
}

export enum AdsCampaignStatus {
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export type AdsCampaignsInput = {
  orderBy: AdsCampaignOrderBy;
  status?: InputMaybe<AdsCampaignStatus>;
};

export type AdvertisementStatisticsEntity = {
  __typename?: 'AdvertisementStatisticsEntity';
  displayAt: AdDisplayAt;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platformType: AdPlatformType;
  targetType: AdTargetType;
};

export type AdvertisementStatisticsEntryEntity = {
  __typename?: 'AdvertisementStatisticsEntryEntity';
  adsAdvertisement: AdvertisementStatisticsEntity;
  advertisementStatisticsMapsEntity: AdvertisementStatisticsMapsEntity;
};

export type AdvertisementStatisticsMapsEntity = {
  __typename?: 'AdvertisementStatisticsMapsEntity';
  clicksEntries: Array<StatisticsMap>;
  impressionsEntries: Array<StatisticsMap>;
};

export type AppEntity = {
  __typename?: 'AppEntity';
  domain: Scalars['String']['output'];
  geminiBrandAndOfferStrategy?: Maybe<GeminiBrandAndOfferStrategy>;
  geminiTaggingPrompt?: Maybe<Scalars['String']['output']>;
  genericProductSource?: Maybe<AppEntity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  taggingStrategy?: Maybe<TaggingStrategy>;
};

export type AppLanguageEntity = {
  __typename?: 'AppLanguageEntity';
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
};

export type AppLanguageInput = {
  id: Scalars['ID']['input'];
};

/** A consumer of the app: either an account (identity_user) or a guest newsletter subscriber. */
export type AppUserEntity = {
  __typename?: 'AppUserEntity';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  kind: AppUserKind;
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum AppUserKind {
  IdentityUser = 'IDENTITY_USER',
  NewsletterSubscriber = 'NEWSLETTER_SUBSCRIBER'
}

export type AppUsersInput = {
  orderBy: IdentityUserOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveHotspotFieldsInput = {
  hotspotFields: Array<HotspotApprovalField>;
  hotspotId: Scalars['ID']['input'];
};

export type ApproveMergeRequestAsNew = {
  __typename?: 'ApproveMergeRequestAsNew';
  brochure?: Maybe<BrochureEntity>;
  status: MutatedStatus;
};

export type ApproveMergeRequestAsNewInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type ApproveMergeRequestAsUpdate = {
  __typename?: 'ApproveMergeRequestAsUpdate';
  status: MutatedStatus;
};

export type ApproveMergeRequestAsUpdateInput = {
  mergeRequestId: Scalars['ID']['input'];
  pageFilters?: InputMaybe<Array<PageFilter>>;
};

export type ApprovedAtHotspotField = {
  __typename?: 'ApprovedAtHotspotField';
  brandApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  descriptionApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  nameApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  offerCategoryApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  priceApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  urlApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  user: IdentityUserEntity;
};

export type AssigneeBrochureLog = BrochureLogEntity & {
  __typename?: 'AssigneeBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum AutoParserType {
  Publitas = 'PUBLITAS',
  Publitasv3 = 'PUBLITASV3',
  Wepublish = 'WEPUBLISH',
  Wepublishv3 = 'WEPUBLISHV3'
}

export type BrandEntity = {
  __typename?: 'BrandEntity';
  app?: Maybe<AppEntity>;
  brandTags: Array<BrandTagEntity>;
  description?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status?: Maybe<BrandStatus>;
  syncSource?: Maybe<BrandEntity>;
};


export type BrandEntityFileUrlArgs = {
  version: BrandFileVersion;
};

export enum BrandFileVersion {
  Small = 'SMALL'
}

export type BrandInput = {
  brandId: Scalars['ID']['input'];
};

export enum BrandOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum BrandStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type BrandTagEntity = {
  __typename?: 'BrandTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BrandsInput = {
  orderBy: BrandOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BrochureCityEntity = {
  __typename?: 'BrochureCityEntity';
  position: Scalars['Int']['output'];
};

export type BrochureCountersInput = {
  brochureExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
  toplevelCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BrochureCreateStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS'
}

export type BrochureDetailStatiticsEntity = {
  __typename?: 'BrochureDetailStatiticsEntity';
  brochure: BrochureStatisticsEntity;
  interaction: InteractionEntryEntity;
  pages: Array<Maybe<PageEntryEntity>>;
};

export type BrochureEntity = {
  __typename?: 'BrochureEntity';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  afterpage: Array<CategoryEntity>;
  assignee?: Maybe<IdentityUserEntity>;
  brochureCity?: Maybe<BrochureCityEntity>;
  brochureExperiment?: Maybe<BrochureExperimentEntity>;
  categories: Array<CategoryEntity>;
  cover?: Maybe<PageEntity>;
  customerLevel?: Maybe<CustomerLevel>;
  expireAfter?: Maybe<Scalars['DateTime']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  language: LanguageEntity;
  local: Scalars['Boolean']['output'];
  mergeRequestAsNew?: Maybe<MergeRequestEntity>;
  mergeRequestAsOld?: Maybe<MergeRequestEntity>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  positionFrozenTo?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  removedProductsFromSearch: Scalars['Boolean']['output'];
  shareUrl?: Maybe<Scalars['String']['output']>;
  shop: ShopEntity;
  state: BrochureState;
  toplevel: Array<CategoryEntity>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
};


export type BrochureEntityBrochureCityArgs = {
  cityId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BrochureExperimentCreateStatus {
  AlreadyInExperiment = 'ALREADY_IN_EXPERIMENT',
  DifferentShops = 'DIFFERENT_SHOPS',
  DuplicateBrochureId = 'DUPLICATE_BROCHURE_ID',
  MergeRequest = 'MERGE_REQUEST',
  NotFound = 'NOT_FOUND',
  NoInboxState = 'NO_INBOX_STATE',
  NoOtherBrochures = 'NO_OTHER_BROCHURES',
  Ok = 'OK'
}

export type BrochureExperimentEntity = {
  __typename?: 'BrochureExperimentEntity';
  brochureExperimentVariants: Array<BrochureExperimentVariantEntity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  variantCount: Scalars['Int']['output'];
};

export type BrochureExperimentVariantEntity = {
  __typename?: 'BrochureExperimentVariantEntity';
  brochureRegions: Array<BrochureRegionEntity>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  variantNumber: Scalars['Int']['output'];
};

export type BrochureInput = {
  brochureId: Scalars['ID']['input'];
};

export type BrochureLogEntity = {
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum BrochureLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type BrochureLogsInput = {
  brochureId: Scalars['ID']['input'];
};

export enum BrochureOrderBy {
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export type BrochurePagesStatisticsEntity = {
  __typename?: 'BrochurePagesStatisticsEntity';
  /** Average read time per page in hours */
  averagePageTime: Scalars['Float']['output'];
  /** Average read time per reader in seconds */
  averageTimePerReader: Scalars['Float']['output'];
  brochure: BrochureStatisticsEntity;
  numberOfPages: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  /** Total read time in hours */
  totalReadTime: Scalars['Float']['output'];
};

export enum BrochurePagesStatisticsOrderBy {
  AveragePageTimeAsc = 'AVERAGE_PAGE_TIME_ASC',
  AveragePageTimeDesc = 'AVERAGE_PAGE_TIME_DESC',
  AverageTimePerReaderAsc = 'AVERAGE_TIME_PER_READER_ASC',
  AverageTimePerReaderDesc = 'AVERAGE_TIME_PER_READER_DESC',
  NumberOfPagesAsc = 'NUMBER_OF_PAGES_ASC',
  NumberOfPagesDesc = 'NUMBER_OF_PAGES_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  ReadsAsc = 'READS_ASC',
  ReadsDesc = 'READS_DESC',
  TotalReadTimeAsc = 'TOTAL_READ_TIME_ASC',
  TotalReadTimeDesc = 'TOTAL_READ_TIME_DESC'
}

export type BrochureReadStatisticsEntity = {
  __typename?: 'BrochureReadStatisticsEntity';
  addedToList: Scalars['Int']['output'];
  brochure: BrochureStatisticsEntity;
  /** @deprecated use hotspotLinkClicksCtr */
  clickThroughRate: Scalars['Float']['output'];
  hotspotClicks: Scalars['Int']['output'];
  hotspotClicksCtr: Scalars['Float']['output'];
  hotspotLinkClicks: Scalars['Int']['output'];
  hotspotLinkClicksCtr: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export enum BrochureReadsStatisticsOrderBy {
  ClickThroughRateAsc = 'CLICK_THROUGH_RATE_ASC',
  ClickThroughRateDesc = 'CLICK_THROUGH_RATE_DESC',
  DeeplinkClicksAsc = 'DEEPLINK_CLICKS_ASC',
  DeeplinkClicksDesc = 'DEEPLINK_CLICKS_DESC',
  ImpressionsAsc = 'IMPRESSIONS_ASC',
  ImpressionsDesc = 'IMPRESSIONS_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  ReadsAsc = 'READS_ASC',
  ReadsDesc = 'READS_DESC'
}

export type BrochureRegionDifference = {
  __typename?: 'BrochureRegionDifference';
  differenceStatus: DifferenceStatus;
  pages: Array<PageDifference>;
  region: RegionEntity;
  /** @deprecated Use region instead */
  regionName: Scalars['String']['output'];
};

export type BrochureRegionEntity = {
  __typename?: 'BrochureRegionEntity';
  brochureExperimentVariant?: Maybe<BrochureExperimentVariantEntity>;
  id: Scalars['ID']['output'];
  parser?: Maybe<ParserEntity>;
  region: RegionEntity;
};

export type BrochureRegionInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export enum BrochureRegionOrderBy {
  RegionNameAsc = 'REGION_NAME_ASC',
  RegionNameDesc = 'REGION_NAME_DESC'
}

export type BrochureRegionsInput = {
  brochureId: Scalars['ID']['input'];
  orderBy: BrochureRegionOrderBy;
};

export enum BrochureState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  ForApproval = 'FOR_APPROVAL',
  Inbox = 'INBOX',
  NotPublished = 'NOT_PUBLISHED',
  ParsingFailed = 'PARSING_FAILED',
  Processing = 'PROCESSING',
  Trash = 'TRASH'
}

export type BrochureStateCount = {
  __typename?: 'BrochureStateCount';
  count: Scalars['Int']['output'];
  state: BrochureState;
};

export type BrochureStateTransitions = {
  __typename?: 'BrochureStateTransitions';
  currentState?: Maybe<TransitionState>;
  status: BrochureTransitionsStatus;
  transitionStates: Array<TransitionState>;
};

export type BrochureStateTransitionsInput = {
  brochureId: Scalars['ID']['input'];
};

export type BrochureStatisticsEntity = {
  __typename?: 'BrochureStatisticsEntity';
  activeFrom: Scalars['DateTime']['output'];
  expireAfter: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Array<Maybe<PageEntity>>>;
  publishedAt: Scalars['DateTime']['output'];
};


export type BrochureStatisticsEntityPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BrochureStatisticsEntryEntity = {
  __typename?: 'BrochureStatisticsEntryEntity';
  brochure: BrochureStatisticsEntity;
  brochureStatisticsMapsEntity: BrochureStatisticsMapsEntity;
};

export enum BrochureStatisticsFileVersion {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type BrochureStatisticsInput = {
  brochureId: Scalars['ID']['input'];
  /** Use this to get the statistics of a specific brochure region. Leave null to get the statistics of the brochure itself. */
  brochureRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrochureStatisticsMapsEntity = {
  __typename?: 'BrochureStatisticsMapsEntity';
  brochureReadsEntries: Array<Maybe<StatisticsMap>>;
  hotspotClicksEntries: Array<Maybe<StatisticsMap>>;
  hotspotLinkClicksEntries: Array<Maybe<StatisticsMap>>;
  impressionsEntries: Array<Maybe<StatisticsMap>>;
  pageReadsEntries: Array<Maybe<StatisticsMap>>;
};

export enum BrochureTransitionsStatus {
  BrochureInvalid = 'BROCHURE_INVALID',
  BrochureNotFound = 'BROCHURE_NOT_FOUND',
  Ok = 'OK'
}

export type BrochuresInput = {
  brochureExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  isToplevel?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: BrochureOrderBy;
  shopId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<BrochureState>;
  toplevelCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrochuresPagesStatisticsInput = {
  orderBy: BrochurePagesStatisticsOrderBy;
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
};

export type BrochuresReadsStatisticsInput = {
  orderBy: BrochureReadsStatisticsOrderBy;
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
};

export type BrochuresStatisticsOverviewInput = {
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: TimeStepEnum;
};

export type BrochuresStatisticsOverviewListResponse = {
  __typename?: 'BrochuresStatisticsOverviewListResponse';
  /** How many times all brochures combined have been read. */
  brochureReads: Scalars['Int']['output'];
  /**
   * How many times all deeplinks combined have been clicked.
   * @deprecated To be removed, please use hotspot_link_clicks.
   */
  deeplinkClicks: Scalars['Int']['output'];
  /** How many times all hotspots have been clicked */
  hotspotClicks: Scalars['Int']['output'];
  /** How many times all external url in hotspots have been clicked */
  hotspotLinkClicks: Scalars['Int']['output'];
  /** Shop id */
  id: Scalars['ID']['output'];
  /** How many times the brochures have been seen. */
  impressions: Scalars['Int']['output'];
  /** How many times all pages combined have been read. */
  pageReads: Scalars['Int']['output'];
  /** An overview of statistics per brochure. Each statistics entity holds key-value pairs for impressions, brochure reads, page reads, and deeplink clicks. */
  statisticsEntries: Array<Maybe<BrochureStatisticsEntryEntity>>;
  /** The sum per key-value pair of the statistics_entries. */
  sumStatisticsEntry: BrochureStatisticsMapsEntity;
};

export type CategoriesInput = {
  languageId: Scalars['ID']['input'];
};

export type CategoryEntity = {
  __typename?: 'CategoryEntity';
  about?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  titleMain?: Maybe<Scalars['String']['output']>;
  titleSecondary?: Maybe<Scalars['String']['output']>;
};


export type CategoryEntityFileUrlArgs = {
  version: CategoryFileVersion;
};

export enum CategoryFileVersion {
  Small = 'SMALL'
}

export type CategoryInput = {
  id: Scalars['ID']['input'];
};

export type ChangePasswordIdentityUserInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type CitiesInput = {
  orderBy: CitiesOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum CitiesOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC'
}

export type CityEntity = {
  __typename?: 'CityEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type CityInput = {
  cityId: Scalars['ID']['input'];
};

export type ClearGeminiPromptCacheInput = {
  shopId: Scalars['ID']['input'];
};

export enum ClientPermissionsScope {
  Dashboard = 'DASHBOARD'
}

export type ClientPermissionsScopeInput = {
  scope: ClientPermissionsScope;
};

export type CloneBrochureRegionInput = {
  /** The BrochureRegion whose pages and hotspots are copied into the new region. Must belong to the same shop. */
  fromBrochureRegionId: Scalars['ID']['input'];
  regionId: Scalars['ID']['input'];
};

export type ConvertHotspotsInput = {
  brochureId: Scalars['ID']['input'];
};

export type ConvertLinkHotspotsStatusEntity = {
  __typename?: 'ConvertLinkHotspotsStatusEntity';
  status: MutatedStatus;
};

export type CopyBrochureRegionInput = {
  fromBrochureRegionId: Scalars['ID']['input'];
  /** The regions to copy into. */
  toRegionIds: Array<Scalars['ID']['input']>;
};

export enum CopyBrochureRegionStatus {
  DestinationAlreadyExists = 'DESTINATION_ALREADY_EXISTS',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  RegionNotInShop = 'REGION_NOT_IN_SHOP',
  SameRegion = 'SAME_REGION'
}

export type CopyBrochureRegionStatusEntity = {
  __typename?: 'CopyBrochureRegionStatusEntity';
  status: CopyBrochureRegionStatus;
};

export type CopyHotspotsInput = {
  fromBrochureRegionId: Scalars['ID']['input'];
  toBrochureRegionId: Scalars['ID']['input'];
};

export enum CopyHotspotsStatus {
  Failed = 'FAILED',
  HotspotsPresent = 'HOTSPOTS_PRESENT',
  NothingToCopy = 'NOTHING_TO_COPY',
  Ok = 'OK',
  UnequalPageCount = 'UNEQUAL_PAGE_COUNT'
}

export type CopyHotspotsStatusEntity = {
  __typename?: 'CopyHotspotsStatusEntity';
  status: CopyHotspotsStatus;
};

export type CreateAdsCampaignAdvertisementHtmlEmbedInput = {
  adsCampaignId: Scalars['ID']['input'];
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  content: Scalars['String']['input'];
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['input'];
  impressionsLimit: Scalars['Int']['input'];
  platformType: AdPlatformType;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  status: AdStatusV2;
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateAdsCampaignAdvertisementImageAdInput = {
  adsCampaignId: Scalars['ID']['input'];
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  impressionsLimit: Scalars['Int']['input'];
  platformType: AdPlatformType;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  status: AdStatusV2;
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateAdsCampaignInput = {
  adDisplayAtPositions: Array<AdDisplayAt>;
  adHtmlContents: Array<AdHtmlContent>;
  adType: AdType;
  adUploads: Array<AdUpload>;
  categoryIds: Array<Scalars['ID']['input']>;
  customerClientId: Scalars['ID']['input'];
  impressionLimit: Scalars['Int']['input'];
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  platforms: Array<AdPlatformType>;
  shopIds: Array<Scalars['ID']['input']>;
  startAt: Scalars['DateTime']['input'];
  stopAt: Scalars['DateTime']['input'];
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateBrandInput = {
  brandTags?: InputMaybe<Array<InputMaybe<CreateBrandTagInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  status: BrandStatus;
};

export type CreateBrandTagInput = {
  name: Scalars['String']['input'];
};

export type CreateBrochureByParser = {
  __typename?: 'CreateBrochureByParser';
  status: CreateBrochureByParserStatus;
};

export type CreateBrochureByParserInput = {
  brochureRegions: Array<CreateBrochureRegionInput>;
  /**
   * Regions that are copied from an existing BrochureRegion instead of being parsed, e.g. to keep regions
   *     unchanged in a merge request. Each region may only appear once across brochure_regions and cloned_brochure_regions.
   */
  clonedBrochureRegions?: InputMaybe<Array<CloneBrochureRegionInput>>;
  id: Scalars['ID']['input'];
  languageId: Scalars['ID']['input'];
  /**
   * If you want to create a new merge request then this field represents the old brochure.
   *     Leave empty if only creating a new brochure.
   */
  mergeRequestBrochureId?: InputMaybe<Scalars['ID']['input']>;
  parserClass: ParserClasses;
  shopId: Scalars['ID']['input'];
};

export enum CreateBrochureByParserStatus {
  CloneNotSupported = 'CLONE_NOT_SUPPORTED',
  CloneSourceNotFound = 'CLONE_SOURCE_NOT_FOUND',
  DuplicateRegion = 'DUPLICATE_REGION',
  MergeRequestAlreadyExists = 'MERGE_REQUEST_ALREADY_EXISTS',
  ProcessingStarted = 'PROCESSING_STARTED',
  RegionAmountMismatch = 'REGION_AMOUNT_MISMATCH'
}

export type CreateBrochureExperimentInput = {
  mainBrochureId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  otherBrochureIds: Array<Scalars['ID']['input']>;
};

export type CreateBrochureLog = BrochureLogEntity & {
  __typename?: 'CreateBrochureLog';
  content: Scalars['String']['output'];
  createStatus: BrochureCreateStatus;
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export type CreateBrochureRegionInput = {
  regionId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type CreateBrochureRegionParams = {
  __typename?: 'CreateBrochureRegionParams';
  region: RegionEntity;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateCategoryInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateCityInput = {
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCustomerClientInput = {
  features?: InputMaybe<Array<CustomerClientFeature>>;
  identityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateGenericProductCategoryInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<GenericProductCategoryTranslationInput>>;
};

export type CreateGenericProductInput = {
  categoryId: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<GenericProductTranslationInput>>;
};

export type CreateHotspotImageInput = {
  file: Scalars['Upload']['input'];
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateHotspotLinkInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateHotspotProductInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  productTag: ProductInput;
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateIdentityUserInput = {
  cityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roles: Array<IdentityUserRole>;
};

export type CreateIdentityUserPasswordResetLinkInput = {
  id: Scalars['ID']['input'];
};

export type CreateLocationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateLocationsByImportInput = {
  locations: Array<LocationByImportInput>;
};

export type CreateNewsletterCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateOfferCategoryInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  offerCategoryTags?: InputMaybe<Array<InputMaybe<CreateOfferCategoryTagInput>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  shopCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateOfferCategoryTagInput = {
  name: Scalars['String']['input'];
};

export type CreatePdfInput = {
  id: Scalars['ID']['input'];
};

export type CreateRegionInput = {
  name: Scalars['String']['input'];
  shopId: Scalars['ID']['input'];
};

export type CreateShopCardTemplateInput = {
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  shopIds: Array<Scalars['ID']['input']>;
};

export type CreateShopInput = {
  autoParserSlugFr?: InputMaybe<Scalars['String']['input']>;
  autoParserSlugNl?: InputMaybe<Scalars['String']['input']>;
  autoParserType?: InputMaybe<AutoParserType>;
  customerClientId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel: CustomerLevel;
  file?: InputMaybe<Scalars['Upload']['input']>;
  geminiTaggingPrompt?: InputMaybe<Scalars['String']['input']>;
  hotspotMode: HotspotMode;
  lastPage: Scalars['Boolean']['input'];
  localBrochures: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  overwriteUtms: Scalars['Boolean']['input'];
  radius: Scalars['Float']['input'];
  removedFromSearch: Scalars['Boolean']['input'];
  removedProductsFromSearch: Scalars['Boolean']['input'];
  /** The categories for which the brochures in the shop can be shown at the end of a brochure after the last page. */
  shopAfterpage: Array<Scalars['ID']['input']>;
  shopCategories: Array<Scalars['ID']['input']>;
  shopDescriptions?: InputMaybe<Array<ShopDescriptionInput>>;
  shopKeywords?: InputMaybe<Scalars['String']['input']>;
  /** The categories for which brochures in the shop can be shown as the top of a brochure stack. */
  shopToplevel: Array<Scalars['ID']['input']>;
  showAds: Scalars['Boolean']['input'];
};

export type CreateWebsitePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  contentQuestionsAnswers?: InputMaybe<Array<WebsitePageQuestionAnswerInput>>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  positionInFooter?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleQuestionsAnswers?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWebsitePostInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  content: Scalars['String']['input'];
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Current User */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  bio?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Scalars['String']['output']>>;
};


/** Current User */
export type CurrentUserFileUrlArgs = {
  version: CurrentUserFileVersion;
};

export enum CurrentUserFileVersion {
  Small = 'SMALL'
}

export type CustomerClientEntity = {
  __typename?: 'CustomerClientEntity';
  apiKey?: Maybe<Scalars['String']['output']>;
  features: Array<CustomerClientFeature>;
  id: Scalars['ID']['output'];
  identityUsers: Array<Maybe<IdentityUserEntity>>;
  name: Scalars['String']['output'];
  shops: Array<Maybe<ShopEntity>>;
};

export enum CustomerClientFeature {
  BrochureCreate = 'BROCHURE_CREATE',
  BrochureEmbed = 'BROCHURE_EMBED',
  Statistics = 'STATISTICS'
}

export type CustomerClientInput = {
  customerClientId: Scalars['ID']['input'];
};

export enum CustomerClientOrderBy {
  NameAtAsc = 'NAME_AT_ASC',
  NameAtDesc = 'NAME_AT_DESC'
}

export enum CustomerClientPermission {
  BrochureCreate = 'BROCHURE_CREATE',
  Statistics = 'STATISTICS'
}

export type CustomerClientsInput = {
  orderBy: CustomerClientOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerLevel {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export type DeleteAdsCampaignAdvertisementInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAdsCampaignInput = {
  id: Scalars['ID']['input'];
};

export type DeleteBrandInput = {
  id: Scalars['ID']['input'];
};

export type DeleteBrandTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCityInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGenericProductCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGenericProductInput = {
  id: Scalars['ID']['input'];
};

export type DeleteHotspotInput = {
  id: Scalars['ID']['input'];
};

export type DeleteHotspotsInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type DeleteHotspotsStatus = {
  __typename?: 'DeleteHotspotsStatus';
  status: MutatedStatus;
};

export type DeleteIdentityUserInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLocationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLocationsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteNewsletterCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNewsletterSubscriberInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOfferCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOfferCategoryTagInput = {
  id: Scalars['ID']['input'];
};

export type DeletePageInput = {
  id: Scalars['ID']['input'];
};

export enum DeletePageStatus {
  BrochureInActiveState = 'BROCHURE_IN_ACTIVE_STATE',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type DeletePdfInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProductPricesInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type DeleteProductPricesStatus = {
  __typename?: 'DeleteProductPricesStatus';
  status: MutatedStatus;
};

export type DeleteRegionInput = {
  regionId: Scalars['ID']['input'];
};

export type DeleteRegionsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteWebsitePageInput = {
  id: Scalars['ID']['input'];
};

export type DeliveryFailureReportEntity = {
  __typename?: 'DeliveryFailureReportEntity';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type DeliveryFailureReportInput = {
  newsletterCategoryId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  subscriberId: Scalars['ID']['input'];
};

export type DetectHotspotsForPageInput = {
  pageId: Scalars['ID']['input'];
};

export type DetectProductHotspotsEntity = {
  __typename?: 'DetectProductHotspotsEntity';
  status: DetectProductHotspotsState;
};

export type DetectProductHotspotsInput = {
  brochureId: Scalars['ID']['input'];
};

export enum DetectProductHotspotsState {
  Ok = 'OK'
}

export enum DifferenceStatus {
  Added = 'ADDED',
  Changed = 'CHANGED',
  NoChanges = 'NO_CHANGES',
  Removed = 'REMOVED'
}

export type ExportLocationsInput = {
  shopId: Scalars['ID']['input'];
};

export type ExportToPdfInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type ExportToPdfResponse = {
  __typename?: 'ExportToPdfResponse';
  status?: Maybe<MutatedStatus>;
};

export enum GeminiBrandAndOfferStrategy {
  Legacy = 'LEGACY',
  WithSuggestions = 'WITH_SUGGESTIONS'
}

export type GeneralFields = {
  activeFrom: Scalars['DateTime']['input'];
  expireAfter: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  publishedAt: Scalars['DateTime']['input'];
};

export type GenericProductCategoryEntity = GenericTreeItem & {
  __typename?: 'GenericProductCategoryEntity';
  ancestors: Array<GenericProductCategoryEntity>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['ID']['output']>;
  published: Scalars['Boolean']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations: Array<GenericProductCategoryTranslationEntity>;
};


export type GenericProductCategoryEntityImageUrlArgs = {
  version: GenericProductImageVersion;
};

export type GenericProductCategoryInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericProductCategoryTranslationEntity = {
  __typename?: 'GenericProductCategoryTranslationEntity';
  language: LanguageEntity;
  translation: Scalars['String']['output'];
};

export type GenericProductCategoryTranslationInput = {
  languageId: Scalars['ID']['input'];
  translation: Scalars['String']['input'];
};

export type GenericProductEntity = GenericTreeItem & {
  __typename?: 'GenericProductEntity';
  ancestors: Array<GenericProductCategoryEntity>;
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations: Array<GenericProductTranslationEntity>;
};


export type GenericProductEntityImageUrlArgs = {
  version: GenericProductImageVersion;
};

export enum GenericProductImageVersion {
  Original = 'ORIGINAL'
}

export type GenericProductInput = {
  id: Scalars['ID']['input'];
};

export type GenericProductTranslationEntity = {
  __typename?: 'GenericProductTranslationEntity';
  language: LanguageEntity;
  translation: Scalars['String']['output'];
};

export type GenericProductTranslationInput = {
  languageId: Scalars['ID']['input'];
  translation: Scalars['String']['input'];
};

export type GenericProductsInput = {
  genericProductCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericTreeItem = {
  ancestors: Array<GenericProductCategoryEntity>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GenericTreeItemImageUrlArgs = {
  version: GenericProductImageVersion;
};

export type GenericTreeItemsInput = {
  /**
   * The parent category to retrieve items for.
   *     Use the zero GUID (00000000-0000-0000-0000-000000000000) for root categories.
   */
  parentId: Scalars['ID']['input'];
};

export enum HotspotApprovalField {
  Brand = 'BRAND',
  Description = 'DESCRIPTION',
  Name = 'NAME',
  OfferCategory = 'OFFER_CATEGORY',
  Price = 'PRICE',
  Url = 'URL'
}

export type HotspotDifference = {
  __typename?: 'HotspotDifference';
  differenceStatus: DifferenceStatus;
  differences: Array<HotspotMatchDifference>;
  newHotspot?: Maybe<HotspotEntity>;
  oldHotspot?: Maybe<HotspotEntity>;
};

export type HotspotEntity = {
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum HotspotFileVersion {
  Original = 'ORIGINAL',
  Small = 'SMALL'
}

export type HotspotImageEntity = HotspotEntity & {
  __typename?: 'HotspotImageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotImageEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export type HotspotInput = {
  hotspotId: Scalars['ID']['input'];
};

export type HotspotLinkEntity = HotspotEntity & {
  __typename?: 'HotspotLinkEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotLinkEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export enum HotspotMatchDifference {
  Coordinates = 'COORDINATES',
  ProductFields = 'PRODUCT_FIELDS',
  Type = 'TYPE',
  Url = 'URL'
}

export enum HotspotMode {
  Disabled = 'DISABLED',
  Links = 'LINKS',
  ProductsWithoutLink = 'PRODUCTS_WITHOUT_LINK',
  ProductsWithLink = 'PRODUCTS_WITH_LINK'
}

export enum HotspotOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type HotspotPlacementInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type HotspotProductEntity = HotspotEntity & {
  __typename?: 'HotspotProductEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Json']['output']>;
  page: PageEntity;
  productTag: ProductTagEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotProductEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export type HotspotStatistics = {
  __typename?: 'HotspotStatistics';
  brochureId: Scalars['ID']['output'];
  externalUrl?: Maybe<Scalars['String']['output']>;
  hotspot?: Maybe<HotspotEntity>;
  hotspotId: Scalars['ID']['output'];
  linkClicks: Scalars['Int']['output'];
  linkTimeSpent: Scalars['Float']['output'];
  pageIndex: Scalars['Int']['output'];
  productClicks: Scalars['Int']['output'];
  productLinkClicks: Scalars['Int']['output'];
  productLinkTimeSpent: Scalars['Float']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productSource?: Maybe<Scalars['String']['output']>;
  productTimeSpent: Scalars['Float']['output'];
  searchImpressions: Scalars['Int']['output'];
  searchProductClicks: Scalars['Int']['output'];
  timesAddedToList: Scalars['Int']['output'];
};

export enum HotspotStatisticsOrderBy {
  LinkClicksAsc = 'LINK_CLICKS_ASC',
  LinkClicksDesc = 'LINK_CLICKS_DESC',
  LinkTimeSpentAsc = 'LINK_TIME_SPENT_ASC',
  LinkTimeSpentDesc = 'LINK_TIME_SPENT_DESC',
  PageIndexAsc = 'PAGE_INDEX_ASC',
  PageIndexDesc = 'PAGE_INDEX_DESC',
  ProductClicksAsc = 'PRODUCT_CLICKS_ASC',
  ProductClicksDesc = 'PRODUCT_CLICKS_DESC',
  ProductLinkClicksAsc = 'PRODUCT_LINK_CLICKS_ASC',
  ProductLinkClicksDesc = 'PRODUCT_LINK_CLICKS_DESC',
  ProductLinkTimeSpentAsc = 'PRODUCT_LINK_TIME_SPENT_ASC',
  ProductLinkTimeSpentDesc = 'PRODUCT_LINK_TIME_SPENT_DESC',
  ProductTimeSpentAsc = 'PRODUCT_TIME_SPENT_ASC',
  ProductTimeSpentDesc = 'PRODUCT_TIME_SPENT_DESC',
  SearchImpressionsAsc = 'SEARCH_IMPRESSIONS_ASC',
  SearchImpressionsDesc = 'SEARCH_IMPRESSIONS_DESC',
  SearchProductClicksAsc = 'SEARCH_PRODUCT_CLICKS_ASC',
  SearchProductClicksDesc = 'SEARCH_PRODUCT_CLICKS_DESC',
  TimesAddedToListAsc = 'TIMES_ADDED_TO_LIST_ASC',
  TimesAddedToListDesc = 'TIMES_ADDED_TO_LIST_DESC'
}

export type HotspotsInput = {
  orderBy: HotspotOrderBy;
  pageId: Scalars['ID']['input'];
};

export type HotspotsStatisticsInput = {
  brochureId: Scalars['ID']['input'];
  /** Use this to get the statistics of a specific brochure region. Leave null to get the statistics of the brochure itself. */
  brochureRegionId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: HotspotStatisticsOrderBy;
};

export type IdentityUserEntity = {
  __typename?: 'IdentityUserEntity';
  bio?: Maybe<Scalars['String']['output']>;
  cities: Array<CityEntity>;
  customerClients: Array<CustomerClientEntity>;
  email: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<IdentityUserRole>;
};


export type IdentityUserEntityFileUrlArgs = {
  version: IdentityUserFileVersion;
};

export enum IdentityUserFileVersion {
  Small = 'SMALL'
}

export type IdentityUserInput = {
  id: Scalars['ID']['input'];
};

export enum IdentityUserOrderBy {
  EmailAtAsc = 'EMAIL_AT_ASC',
  EmailAtDesc = 'EMAIL_AT_DESC'
}

export enum IdentityUserRole {
  Admin = 'ADMIN',
  AdManager = 'AD_MANAGER',
  CityManager = 'CITY_MANAGER',
  Client = 'CLIENT',
  ClientManager = 'CLIENT_MANAGER',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  StatisticsManager = 'STATISTICS_MANAGER',
  Superadmin = 'SUPERADMIN',
  Tagger = 'TAGGER',
  TagManager = 'TAG_MANAGER'
}

export type IdentityUsersInput = {
  orderBy: IdentityUserOrderBy;
  roles?: InputMaybe<Array<InputMaybe<IdentityUserRole>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ImportLocationsInput = {
  file: Scalars['Upload']['input'];
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
};

export type ImportedLocationEntity = {
  __typename?: 'ImportedLocationEntity';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  point?: Maybe<LocationPoint>;
  regionId: Scalars['ID']['output'];
  shopId: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export enum InteractionCategoryEnum {
  /** From the also interesting screen */
  AlsoInteresting = 'ALSO_INTERESTING',
  /** From the share link */
  AppLink = 'APP_LINK',
  /** From the category screen */
  Category = 'CATEGORY',
  /** From the favorites screen */
  Favorites = 'FAVORITES',
  /** When a brochure is visited from recommendations given on a generic product */
  GenericProductRecommendations = 'GENERIC_PRODUCT_RECOMMENDATIONS',
  /** From the new offers screen */
  NewOpen = 'NEW_OPEN',
  /** When a brochure is still op when reopening from the background */
  ReopenBackground = 'REOPEN_BACKGROUND',
  /** As a result of searching */
  Search = 'SEARCH',
  /** When a brochure is seen on the shop card's detail page. */
  ShopCard = 'SHOP_CARD',
  /** From the main categories overview */
  Stack = 'STACK'
}

export type InteractionEntryEntity = {
  __typename?: 'InteractionEntryEntity';
  addedToList: Scalars['Int']['output'];
  /** @deprecated use hotspotLinkClicksCtr */
  clickThroughRate: Scalars['Float']['output'];
  hotspotClicks: Scalars['Int']['output'];
  hotspotClicksCtr: Scalars['Float']['output'];
  hotspotLinkClicks: Scalars['Int']['output'];
  hotspotLinkClicksCtr: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  interactionEntries: Array<Maybe<InteractionMap>>;
  openingRatio: Scalars['Float']['output'];
  reach: Scalars['Int']['output'];
  readers: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export type InteractionMap = {
  __typename?: 'InteractionMap';
  category: InteractionCategoryEnum;
  impressions: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export type LanguageEntity = {
  __typename?: 'LanguageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};


export type LanguageEntityFileUrlArgs = {
  version: LanguageFileVersion;
};

export enum LanguageFileVersion {
  Small = 'SMALL'
}

export type LanguageInput = {
  languageId: Scalars['ID']['input'];
};

export type LocationByImportInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  point: Point;
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
  zipCode: Scalars['String']['input'];
};

export type LocationEntity = {
  __typename?: 'LocationEntity';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  point?: Maybe<LocationPoint>;
  region: RegionEntity;
  zipCode: Scalars['String']['output'];
};

export type LocationInput = {
  locationId: Scalars['ID']['input'];
};

export type LocationPoint = {
  __typename?: 'LocationPoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type MergeRequestDetails = {
  __typename?: 'MergeRequestDetails';
  brochureRegions: Array<BrochureRegionDifference>;
  mergeRequest: MergeRequestEntity;
};

export type MergeRequestEntity = {
  __typename?: 'MergeRequestEntity';
  id: Scalars['ID']['output'];
  newBrochure: BrochureEntity;
  status: MergeRequestStatus;
};

export type MergeRequestInput = {
  id: Scalars['ID']['input'];
};

export enum MergeRequestOrderBy {
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export enum MergeRequestStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type MergeRequestsInput = {
  orderBy: MergeRequestOrderBy;
  status: MergeRequestStatus;
};

export type MigrateBrochureRegionMyshopiInput = {
  brochureRegionId: Scalars['ID']['input'];
  /** The ID of a brochure in myShopi to create a merge request for. Leave empty to only copy this brochure. */
  recreateBrochureId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutatedChangePasswordIdentityUser = {
  __typename?: 'MutatedChangePasswordIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedCreateAdsCampaign = {
  __typename?: 'MutatedCreateAdsCampaign';
  adsCampaign?: Maybe<AdsCampaignEntity>;
  status?: Maybe<MutatedStatus>;
};

export type MutatedCreateBrochureExperiment = {
  __typename?: 'MutatedCreateBrochureExperiment';
  brochureExperiment?: Maybe<BrochureExperimentEntity>;
  status: BrochureExperimentCreateStatus;
};

export type MutatedCreateIdentityUser = {
  __typename?: 'MutatedCreateIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedCreateIdentityUserPasswordResetLink = {
  __typename?: 'MutatedCreateIdentityUserPasswordResetLink';
  url: Scalars['String']['output'];
};

export type MutatedCreateLocationsByImport = {
  __typename?: 'MutatedCreateLocationsByImport';
  status: MutatedStatus;
};

export type MutatedCreateShopCardTemplate = {
  __typename?: 'MutatedCreateShopCardTemplate';
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  status: MutatedStatus;
};

export type MutatedDeleteAdsAdvertisement = {
  __typename?: 'MutatedDeleteAdsAdvertisement';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteAdsCampaign = {
  __typename?: 'MutatedDeleteAdsCampaign';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteBrand = {
  __typename?: 'MutatedDeleteBrand';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteBrandTag = {
  __typename?: 'MutatedDeleteBrandTag';
  status: MutatedStatus;
};

export type MutatedDeleteCity = {
  __typename?: 'MutatedDeleteCity';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteGenericProduct = {
  __typename?: 'MutatedDeleteGenericProduct';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteGenericProductCategory = {
  __typename?: 'MutatedDeleteGenericProductCategory';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteHotspot = {
  __typename?: 'MutatedDeleteHotspot';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteIdentityUser = {
  __typename?: 'MutatedDeleteIdentityUser';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteLocation = {
  __typename?: 'MutatedDeleteLocation';
  status: MutatedStatus;
};

export type MutatedDeleteLocations = {
  __typename?: 'MutatedDeleteLocations';
  status: MutatedStatus;
};

export type MutatedDeleteNewsletterSubscriber = {
  __typename?: 'MutatedDeleteNewsletterSubscriber';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteOfferCategory = {
  __typename?: 'MutatedDeleteOfferCategory';
  status: MutatedStatus;
};

export type MutatedDeleteOfferCategoryTag = {
  __typename?: 'MutatedDeleteOfferCategoryTag';
  status: MutatedStatus;
};

export type MutatedDeletePage = {
  __typename?: 'MutatedDeletePage';
  status: DeletePageStatus;
};

export type MutatedDeletePdf = {
  __typename?: 'MutatedDeletePdf';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteRegion = {
  __typename?: 'MutatedDeleteRegion';
  status: MutatedStatus;
};

export type MutatedDeleteRegions = {
  __typename?: 'MutatedDeleteRegions';
  status: MutatedStatus;
};

export type MutatedDeleteWebsitePage = {
  __typename?: 'MutatedDeleteWebsitePage';
  status?: Maybe<MutatedStatus>;
};

export type MutatedExportLocations = {
  __typename?: 'MutatedExportLocations';
  fileUrl?: Maybe<Scalars['String']['output']>;
  status: MutatedStatus;
};

export type MutatedImportLocations = {
  __typename?: 'MutatedImportLocations';
  locationCount: Scalars['Int']['output'];
  status: MutatedImportLocationsStatus;
};

export enum MutatedImportLocationsStatus {
  Ok = 'OK'
}

export type MutatedLocation = {
  __typename?: 'MutatedLocation';
  location?: Maybe<LocationEntity>;
  status: MutatedLocationStatus;
};

export enum MutatedLocationStatus {
  Failed = 'FAILED',
  GeocodeFailedToFindLocation = 'GEOCODE_FAILED_TO_FIND_LOCATION',
  Ok = 'OK'
}

export type MutatedMergeRequest = {
  __typename?: 'MutatedMergeRequest';
  status: MutatedStatus;
};

export type MutatedMigrateBrochureRegionMyshopi = {
  __typename?: 'MutatedMigrateBrochureRegionMyshopi';
  status: MutatedStatus;
};

export type MutatedRegion = {
  __typename?: 'MutatedRegion';
  region?: Maybe<RegionEntity>;
  status: MutatedStatus;
};

export type MutatedResetPasswordIdentityUser = {
  __typename?: 'MutatedResetPasswordIdentityUser';
  status?: Maybe<ResetPasswordStatus>;
};

export type MutatedSetPasswordIdentityUser = {
  __typename?: 'MutatedSetPasswordIdentityUser';
  status?: Maybe<SetPasswordStatus>;
};

export type MutatedShop = {
  __typename?: 'MutatedShop';
  shop?: Maybe<AdminShopEntity>;
  status: MutatedStatus;
};

export enum MutatedStatus {
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type MutatedUnsubscribeIdentityUserFromNewsletters = {
  __typename?: 'MutatedUnsubscribeIdentityUserFromNewsletters';
  status?: Maybe<MutatedStatus>;
};

export type MutatedUnsubscribeNewsletterSubscriberFromNewsletters = {
  __typename?: 'MutatedUnsubscribeNewsletterSubscriberFromNewsletters';
  status?: Maybe<MutatedStatus>;
};

export type MutatedUpdateBrochure = {
  __typename?: 'MutatedUpdateBrochure';
  brochure?: Maybe<BrochureEntity>;
  status: UpdateBrochureStatus;
};

export type MutatedUpdateBrochureAssignee = {
  __typename?: 'MutatedUpdateBrochureAssignee';
  brochure?: Maybe<BrochureEntity>;
  status: UpdateBrochureAssigneeStatus;
};

export type MutatedUpdateCurrentUser = {
  __typename?: 'MutatedUpdateCurrentUser';
  currentUser?: Maybe<CurrentUser>;
};

export type MutatedUpdateIdentityUser = {
  __typename?: 'MutatedUpdateIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedUpdateShopCardTemplate = {
  __typename?: 'MutatedUpdateShopCardTemplate';
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  status: MutatedUpdateShopCardTemplateStatus;
};

export enum MutatedUpdateShopCardTemplateStatus {
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type MutatedUpsertBrochureCity = {
  __typename?: 'MutatedUpsertBrochureCity';
  status: UpdateBrochureStatus;
};

export type MutatedUpsertSessionStatus = {
  __typename?: 'MutatedUpsertSessionStatus';
  status: MutatedStatus;
};

export type MyshopiShopBrochuresInput = {
  languageId: Scalars['ID']['input'];
  shopName: Scalars['String']['input'];
};

export type NewsletterCategoryEntity = {
  __typename?: 'NewsletterCategoryEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NewsletterSubscriberActive = {
  __typename?: 'NewsletterSubscriberActive';
  emailAddress: Scalars['String']['output'];
  favoriteShops?: Maybe<Array<ShopEntity>>;
  firstName?: Maybe<Scalars['String']['output']>;
  languageCode: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  unsubscribeToken: Scalars['String']['output'];
};

export type NewsletterSubscriberDeleted = {
  __typename?: 'NewsletterSubscriberDeleted';
  deletedAt: Scalars['NaiveDateTime']['output'];
};

export type NewsletterSubscriberEntity = {
  __typename?: 'NewsletterSubscriberEntity';
  deliveryFailureReports: Array<DeliveryFailureReportEntity>;
  id: Scalars['ID']['output'];
  newsletterCategories: Array<NewsletterCategoryEntity>;
  status: NewsletterSubscriberStatus;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

export type NewsletterSubscriberStatus = NewsletterSubscriberActive | NewsletterSubscriberDeleted;

export type OfferCategoriesInput = {
  languageId: Scalars['ID']['input'];
  orderBy: OfferCategoryOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OfferCategoryBlacklistTagEntity = {
  __typename?: 'OfferCategoryBlacklistTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OfferCategoryEntity = {
  __typename?: 'OfferCategoryEntity';
  app?: Maybe<AppEntity>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
  name: Scalars['String']['output'];
  offerCategoryBlacklistTags: Array<OfferCategoryBlacklistTagEntity>;
  offerCategoryTags: Array<OfferCategoryTagEntity>;
  position?: Maybe<Scalars['Int']['output']>;
  shopCategories: Array<CategoryEntity>;
  syncSource?: Maybe<OfferCategoryEntity>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferCategoryInput = {
  id: Scalars['ID']['input'];
};

export enum OfferCategoryOrderBy {
  /** Puts items most similar to the search string first; equal to name_asc if not searching */
  Likeness = 'LIKENESS',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type OfferCategoryTagEntity = {
  __typename?: 'OfferCategoryTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OfferCategoryTagSuggestionsInput = {
  hotspotId: Scalars['ID']['input'];
  offerCategoryId: Scalars['ID']['input'];
};

export type OfferInputSuggestion = {
  __typename?: 'OfferInputSuggestion';
  brands: Array<BrandEntity>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerCategories: Array<OfferCategoryEntity>;
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type OfferOcrSuggestion = {
  __typename?: 'OfferOcrSuggestion';
  croppedBlocks: Array<VisionBlock>;
  offerInputSuggestion?: Maybe<OfferInputSuggestion>;
  processor: OfferOcrSuggestionProcessorName;
  processorResponse?: Maybe<Scalars['String']['output']>;
};

export type OfferOcrSuggestionHotspotInput = {
  /** A saved hotspot. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** An area on a page, e.g. for a hotspot that hasn't been saved yet. */
  placement?: InputMaybe<HotspotPlacementInput>;
};

export enum OfferOcrSuggestionProcessor {
  Gemini = 'GEMINI'
}

export enum OfferOcrSuggestionProcessorName {
  Gemini = 'GEMINI'
}

export type PageDifference = {
  __typename?: 'PageDifference';
  added: Scalars['Int']['output'];
  changed: Scalars['Int']['output'];
  differenceStatus: DifferenceStatus;
  hotspots: Array<HotspotDifference>;
  newPage?: Maybe<PageEntity>;
  noChanges: Scalars['Int']['output'];
  oldPage?: Maybe<PageEntity>;
  removed: Scalars['Int']['output'];
};

export type PageEntity = {
  __typename?: 'PageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  hotspots?: Maybe<Array<HotspotEntity>>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
};


export type PageEntityFileUrlArgs = {
  version: BrochureStatisticsFileVersion;
};

export type PageEntryEntity = {
  __typename?: 'PageEntryEntity';
  averageTimeSeconds: Scalars['Float']['output'];
  index: Scalars['Int']['output'];
  percentageReadsPageOne: Scalars['Float']['output'];
  readers: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  totalTimeSeconds: Scalars['Int']['output'];
};

export type PageFilter = {
  pageIndices: Array<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
};

export type PageInput = {
  pageId: Scalars['ID']['input'];
};

export enum PageOrderBy {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC'
}

export type PagesInput = {
  brochureRegionId: Scalars['ID']['input'];
  orderBy: PageOrderBy;
};

export type PagesWithHotspotsInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type PaginatedAdminShops = {
  __typename?: 'PaginatedAdminShops';
  entries: Array<AdminShopEntity>;
  pagination: Pagination;
};

export type PaginatedAdsAdvertisements = {
  __typename?: 'PaginatedAdsAdvertisements';
  entries: Array<AdsAdvertisementEntity>;
  pagination: Pagination;
};

export type PaginatedAdsCampaigns = {
  __typename?: 'PaginatedAdsCampaigns';
  entries: Array<AdsCampaignEntity>;
  pagination: Pagination;
};

export type PaginatedAppUsers = {
  __typename?: 'PaginatedAppUsers';
  entries: Array<AppUserEntity>;
  pagination: Pagination;
};

export type PaginatedBrands = {
  __typename?: 'PaginatedBrands';
  entries: Array<BrandEntity>;
  pagination: Pagination;
};

export type PaginatedBrochureLogs = {
  __typename?: 'PaginatedBrochureLogs';
  entries: Array<BrochureLogEntity>;
  pagination: Pagination;
};

export type PaginatedBrochures = {
  __typename?: 'PaginatedBrochures';
  entries: Array<BrochureEntity>;
  pagination: Pagination;
};

export type PaginatedCities = {
  __typename?: 'PaginatedCities';
  entries: Array<CityEntity>;
  pagination: Pagination;
};

export type PaginatedCustomerClients = {
  __typename?: 'PaginatedCustomerClients';
  entries: Array<CustomerClientEntity>;
  pagination: Pagination;
};

export type PaginatedGenericTreeItems = {
  __typename?: 'PaginatedGenericTreeItems';
  entries: Array<GenericTreeItem>;
  pagination: Pagination;
};

export type PaginatedIdentityUsers = {
  __typename?: 'PaginatedIdentityUsers';
  entries: Array<IdentityUserEntity>;
  pagination: Pagination;
};

export type PaginatedNewsletterSubscribers = {
  __typename?: 'PaginatedNewsletterSubscribers';
  entries: Array<NewsletterSubscriberEntity>;
  pagination: Pagination;
};

export type PaginatedOfferCategories = {
  __typename?: 'PaginatedOfferCategories';
  entries: Array<OfferCategoryEntity>;
  pagination: Pagination;
};

export type PaginatedPagesWithHotspots = {
  __typename?: 'PaginatedPagesWithHotspots';
  entries: Array<PageEntity>;
  pagination: Pagination;
};

export type PaginatedShopCardTemplates = {
  __typename?: 'PaginatedShopCardTemplates';
  entries: Array<ShopCardTemplateEntity>;
  pagination: Pagination;
};

export type PaginatedShops = {
  __typename?: 'PaginatedShops';
  entries: Array<ShopEntity>;
  pagination: Pagination;
};

export type PaginatedWebsitePages = {
  __typename?: 'PaginatedWebsitePages';
  entries: Array<WebsitePageEntity>;
  pagination: Pagination;
};

/** Pagination */
export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  previousPage?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum ParseMethod {
  CreateByUrl = 'CREATE_BY_URL',
  Duplicate = 'DUPLICATE'
}

export type ParserClassByUrlInput = {
  url: Scalars['String']['input'];
};

export type ParserClassEntity = {
  __typename?: 'ParserClassEntity';
  class: ParserClasses;
  moduleName: ParserClasses;
};

export enum ParserClasses {
  Colruyt = 'COLRUYT',
  DuplicateBrochure = 'DUPLICATE_BROCHURE',
  Folderscheck = 'FOLDERSCHECK',
  Folderz = 'FOLDERZ',
  FolderzV2 = 'FOLDERZ_V2',
  IssuuV2 = 'ISSUU_V2',
  LidlFlyer = 'LIDL_FLYER',
  Pdf = 'PDF',
  PublishV2 = 'PUBLISH_V2',
  Publitas = 'PUBLITAS',
  PublitasV2 = 'PUBLITAS_V2',
  PublitasV3 = 'PUBLITAS_V3',
  ReclameFolder = 'RECLAME_FOLDER',
  WePublish = 'WE_PUBLISH',
  WePublishV2 = 'WE_PUBLISH_V2',
  WePublishV3 = 'WE_PUBLISH_V3',
  Yumpu = 'YUMPU',
  YumpuV2 = 'YUMPU_V2'
}

export type ParserEntity = {
  __typename?: 'ParserEntity';
  parserClass: ParserClassEntity;
  url: Scalars['String']['output'];
};

export type ParserParameters = {
  __typename?: 'ParserParameters';
  parserClass?: Maybe<ParserClasses>;
  parsers: Array<CreateBrochureRegionParams>;
};

export type ParserParametersInput = {
  brochureId: Scalars['ID']['input'];
  method: ParseMethod;
};

export type PdfEntity = {
  __typename?: 'PdfEntity';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PdfMessageEntity = {
  __typename?: 'PdfMessageEntity';
  coverUrl?: Maybe<Scalars['String']['output']>;
  indexUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  pdfId: Scalars['ID']['output'];
};

export type Point = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type PositionBrochureLog = BrochureLogEntity & {
  __typename?: 'PositionBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum PostProcessingStatus {
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS'
}

export type PostProcessingStatusInput = {
  brochureId: Scalars['ID']['input'];
};

export type ProductInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offerCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priceAfterDiscount?: InputMaybe<Scalars['Float']['input']>;
  priceBeforeDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductTagEntity = {
  __typename?: 'ProductTagEntity';
  brand?: Maybe<BrandEntity>;
  brandName?: Maybe<Scalars['String']['output']>;
  brands: Array<BrandEntity>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offerCategories: Array<OfferCategoryEntity>;
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type PublicBrochuresInput = {
  languageId: Scalars['ID']['input'];
  point?: InputMaybe<Point>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishMergeRequestInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type RegionEntity = {
  __typename?: 'RegionEntity';
  id: Scalars['ID']['output'];
  locationsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RegionInput = {
  regionId: Scalars['ID']['input'];
};

export enum RegionOrderBy {
  NameAsc = 'NAME_ASC'
}

export type RegionsInput = {
  orderBy: RegionOrderBy;
  shopId: Scalars['ID']['input'];
};

export type RejectMergeRequestInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type ResetPasswordIdentityUserInput = {
  email: Scalars['String']['input'];
};

export enum ResetPasswordStatus {
  Ok = 'OK'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Approve hotspot fields */
  approveHotspotFields?: Maybe<HotspotEntity>;
  /** Approve request by archiving the old brochure and publishing the new brochure */
  approveMergeRequestAsNew: ApproveMergeRequestAsNew;
  /** Approve request by updating the old brochure with data from the new brochure */
  approveMergeRequestAsUpdate: ApproveMergeRequestAsUpdate;
  /** Change password identity_user */
  changePasswordIdentityUser?: Maybe<MutatedChangePasswordIdentityUser>;
  /** Clears the cached Gemini tagging prompt (all languages) for a shop */
  clearGeminiPromptCache: MutatedShop;
  /** Convert all link hotspots of a brochure to product hotspots */
  convertLinkHotspotsToProductHotspots: ConvertLinkHotspotsStatusEntity;
  /**
   * Copy all pages and hotspots from a BrochureRegion into one or more new regions of the same brochure,
   *     creating the destination BrochureRegion(s). All-or-nothing: fails entirely if the brochure already has a
   *     BrochureRegion for any of the target regions.
   */
  copyBrochureRegion: CopyBrochureRegionStatusEntity;
  /** Copy hotspots from another BrochureRegion, but only if this one has no hotspots yet */
  copyHotspots?: Maybe<CopyHotspotsStatusEntity>;
  /** Create ads_campaign */
  createAdsCampaign: MutatedCreateAdsCampaign;
  /** Create ads_advertisement for html_embed */
  createAdsCampaignAdvertisementHtmlEmbed?: Maybe<AdsAdvertisementEntity>;
  /** Create ads_advertisement for image_ad */
  createAdsCampaignAdvertisementImageAd?: Maybe<AdsAdvertisementEntity>;
  /** Create brand. */
  createBrand?: Maybe<BrandEntity>;
  /** Brochure create by parser */
  createBrochureByParser: CreateBrochureByParser;
  /** Create Brochure Experiment */
  createBrochureExperiment: MutatedCreateBrochureExperiment;
  /** Create category. */
  createCategory?: Maybe<CategoryEntity>;
  /** Create city */
  createCity?: Maybe<CityEntity>;
  /** Create customer_client with a name and set_ids from other customer_clients. */
  createCustomerClient?: Maybe<CustomerClientEntity>;
  createDeliveryFailureReport?: Maybe<DeliveryFailureReportEntity>;
  /** Create a generic product */
  createGenericProduct?: Maybe<GenericProductEntity>;
  /** Create a generic product category */
  createGenericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** Create hotspot image */
  createHotspotImage?: Maybe<HotspotEntity>;
  /** Create hotspot link */
  createHotspotLink?: Maybe<HotspotEntity>;
  /** Create hotspot product */
  createHotspotProduct?: Maybe<HotspotEntity>;
  /** Create identity_user */
  createIdentityUser?: Maybe<MutatedCreateIdentityUser>;
  /** Create a password reset link for an app user, used by customer support */
  createIdentityUserPasswordResetLink?: Maybe<MutatedCreateIdentityUserPasswordResetLink>;
  /** Create location. */
  createLocation: MutatedLocation;
  /** Creates locations based on the result of the import_locations mutation. */
  createLocationsByImport: MutatedCreateLocationsByImport;
  createNewsletterCategory: NewsletterCategoryEntity;
  /** Create offer_category */
  createOfferCategory?: Maybe<OfferCategoryEntity>;
  /** Create pdf. */
  createPdf?: Maybe<PdfEntity>;
  /** Create region. */
  createRegion: MutatedRegion;
  /** Create shop. */
  createShop: MutatedShop;
  /** Create shop_card_template. */
  createShopCardTemplate: MutatedCreateShopCardTemplate;
  /** Create website_page with type page */
  createWebsitePage?: Maybe<WebsitePagePage>;
  /** Create website_page with type post */
  createWebsitePost?: Maybe<WebsitePagePost>;
  /** Delete ads_campaign */
  deleteAdsCampaign?: Maybe<MutatedDeleteAdsCampaign>;
  /**
   * Delete ads_advertisement
   * @deprecated Deleting ads without campaign will no longer be supported: use delete_ads_campaign_advertisement instead
   */
  deleteAdsCampaignAdvertisement?: Maybe<MutatedDeleteAdsAdvertisement>;
  /** Delete brand */
  deleteBrand?: Maybe<MutatedDeleteBrand>;
  /** Delete brand_tag */
  deleteBrandTag: MutatedDeleteBrandTag;
  /** Delete city */
  deleteCity?: Maybe<MutatedDeleteCity>;
  /** Delete a generic product */
  deleteGenericProduct: MutatedDeleteGenericProduct;
  /** Delete a generic product category */
  deleteGenericProductCategory: MutatedDeleteGenericProductCategory;
  /** Delete hotspot */
  deleteHotspot?: Maybe<MutatedDeleteHotspot>;
  /** Delete all hotspots for a brochure region */
  deleteHotspots: DeleteHotspotsStatus;
  /** Delete identity_user */
  deleteIdentityUser?: Maybe<MutatedDeleteIdentityUser>;
  /** Delete location. */
  deleteLocation: MutatedDeleteLocation;
  /** delete multiple locations. */
  deleteLocations: MutatedDeleteLocations;
  deleteNewsletterCategory: MutatedStatus;
  /** Delete a guest newsletter_subscriber */
  deleteNewsletterSubscriber?: Maybe<MutatedDeleteNewsletterSubscriber>;
  /** Delete offer_category */
  deleteOfferCategory?: Maybe<MutatedDeleteOfferCategory>;
  /** Delete offer_category_tag */
  deleteOfferCategoryTag: MutatedDeleteOfferCategoryTag;
  /** Delete page */
  deletePage: MutatedDeletePage;
  /** Delete pdf */
  deletePdf?: Maybe<MutatedDeletePdf>;
  /** Deletes all pricing information for a brochure region */
  deleteProductPrices: DeleteProductPricesStatus;
  /** Delete region. */
  deleteRegion: MutatedDeleteRegion;
  /** Delete multiple regions. */
  deleteRegions: MutatedDeleteRegions;
  /** Delete website_page with type post */
  deleteWebsitePage?: Maybe<MutatedDeleteWebsitePage>;
  /** Detect product hotspots for a single page */
  detectHotspotsForPage: DetectProductHotspotsEntity;
  /** Detect product hotspots on pages without hotspots using Google VertexAI & Vision */
  detectProductHotspots: DetectProductHotspotsEntity;
  /** Export a CSV file with locations including region name. */
  exportLocations: MutatedExportLocations;
  /** Export to pdf */
  exportToPdf: ExportToPdfResponse;
  /** Accepts CSV files. */
  importLocations: MutatedImportLocations;
  migrateBrochureRegionMyshopi: MutatedMigrateBrochureRegionMyshopi;
  /** Publish a merge request by updating its status from draft to pending */
  publishMergeRequest: MutatedMergeRequest;
  /** Reject request by setting the status of the merge request to 'rejected' and putting the new_brochure in trash */
  rejectMergeRequest: MutatedMergeRequest;
  /** Request a password reset link for an identity_user */
  resetPasswordIdentityUser?: Maybe<MutatedResetPasswordIdentityUser>;
  /** Set a new password for an identity_user using a reset token */
  setPasswordIdentityUser?: Maybe<MutatedSetPasswordIdentityUser>;
  /**
   * Sort the children of a generic tree node. Provide decimal sort indices to position
   *     items between existing ones — all items will be re-indexed to a continuous integer sequence.
   */
  sortGenericTreeItems: MutatedStatus;
  /** Unsubscribe identity_user from all newsletters */
  unsubscribeIdentityUserFromNewsletters?: Maybe<MutatedUnsubscribeIdentityUserFromNewsletters>;
  /** Unsubscribe a guest newsletter_subscriber from all newsletters */
  unsubscribeNewsletterSubscriberFromNewsletters?: Maybe<MutatedUnsubscribeNewsletterSubscriberFromNewsletters>;
  /** Update ads_campaign */
  updateAdsCampaign?: Maybe<AdsCampaignEntity>;
  /** Update ads_advertisement for html_embed */
  updateAdsCampaignAdvertisementHtmlEmbed?: Maybe<AdsAdvertisementEntity>;
  /** Update ads_advertisement for image_ad */
  updateAdsCampaignAdvertisementImageAd?: Maybe<AdsAdvertisementEntity>;
  /** Update the current app. */
  updateApp?: Maybe<AppEntity>;
  /** Update an app language. */
  updateAppLanguage?: Maybe<AppLanguageEntity>;
  /** Update brand. */
  updateBrand?: Maybe<BrandEntity>;
  /** Brochure update - with general and/or admin fields */
  updateBrochure: MutatedUpdateBrochure;
  /** Update the assignee on a brochure */
  updateBrochureAssignee: MutatedUpdateBrochureAssignee;
  /** Brochure update for position or fr */
  updateBrochurePosition: MutatedUpdateBrochure;
  /** Brochure update state */
  updateBrochureState?: Maybe<UpdateBrochureState>;
  /** Update category. */
  updateCategory?: Maybe<CategoryEntity>;
  /** Update city */
  updateCity?: Maybe<CityEntity>;
  /** Update current_user */
  updateCurrentUser?: Maybe<MutatedUpdateCurrentUser>;
  /** Update customer_client with a new name or additionals set_ids. */
  updateCustomerClient?: Maybe<CustomerClientEntity>;
  /** Update a generic product */
  updateGenericProduct?: Maybe<GenericProductEntity>;
  /** Update a generic product category */
  updateGenericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** Update hotspot image */
  updateHotspotImage?: Maybe<HotspotEntity>;
  /** Update hotspot link */
  updateHotspotLink?: Maybe<HotspotEntity>;
  /** Update hotspot product */
  updateHotspotProduct?: Maybe<HotspotEntity>;
  /** Update identity_user */
  updateIdentityUser?: Maybe<MutatedUpdateIdentityUser>;
  /** Updates a location */
  updateLocation?: Maybe<MutatedLocation>;
  updateNewsletterCategory: NewsletterCategoryEntity;
  /** Update offer_category */
  updateOfferCategory?: Maybe<OfferCategoryEntity>;
  /** Update region. */
  updateRegion: MutatedRegion;
  /** Update shop. */
  updateShop: MutatedShop;
  /** Update shop_card_template. */
  updateShopCardTemplate: MutatedUpdateShopCardTemplate;
  /** Update website_page with type page */
  updateWebsitePage?: Maybe<WebsitePagePage>;
  /** Update website_page with type post */
  updateWebsitePost?: Maybe<WebsitePagePost>;
  /** Upsert brochure city position */
  upsertBrochureCityPosition: MutatedUpsertBrochureCity;
  /** Upsert session */
  upsertSession: MutatedUpsertSessionStatus;
};


export type RootMutationTypeApproveHotspotFieldsArgs = {
  approveHotspotFields: ApproveHotspotFieldsInput;
};


export type RootMutationTypeApproveMergeRequestAsNewArgs = {
  approveMergeRequestAsNew: ApproveMergeRequestAsNewInput;
};


export type RootMutationTypeApproveMergeRequestAsUpdateArgs = {
  approveMergeRequestAsUpdate: ApproveMergeRequestAsUpdateInput;
};


export type RootMutationTypeChangePasswordIdentityUserArgs = {
  changePasswordIdentityUser: ChangePasswordIdentityUserInput;
};


export type RootMutationTypeClearGeminiPromptCacheArgs = {
  clearGeminiPromptCache: ClearGeminiPromptCacheInput;
};


export type RootMutationTypeConvertLinkHotspotsToProductHotspotsArgs = {
  convertHotspots: ConvertHotspotsInput;
};


export type RootMutationTypeCopyBrochureRegionArgs = {
  copyBrochureRegion: CopyBrochureRegionInput;
};


export type RootMutationTypeCopyHotspotsArgs = {
  copyHotspots: CopyHotspotsInput;
};


export type RootMutationTypeCreateAdsCampaignArgs = {
  createAdsCampaign: CreateAdsCampaignInput;
};


export type RootMutationTypeCreateAdsCampaignAdvertisementHtmlEmbedArgs = {
  createAdsCampaignAdvertisementHtmlEmbed: CreateAdsCampaignAdvertisementHtmlEmbedInput;
};


export type RootMutationTypeCreateAdsCampaignAdvertisementImageAdArgs = {
  createAdsCampaignAdvertisementImageAd: CreateAdsCampaignAdvertisementImageAdInput;
};


export type RootMutationTypeCreateBrandArgs = {
  createBrand: CreateBrandInput;
};


export type RootMutationTypeCreateBrochureByParserArgs = {
  createBrochure: CreateBrochureByParserInput;
};


export type RootMutationTypeCreateBrochureExperimentArgs = {
  createBrochureExperiment: CreateBrochureExperimentInput;
};


export type RootMutationTypeCreateCategoryArgs = {
  createCategory: CreateCategoryInput;
};


export type RootMutationTypeCreateCityArgs = {
  createCity: CreateCityInput;
};


export type RootMutationTypeCreateCustomerClientArgs = {
  createCustomerClient: CreateCustomerClientInput;
};


export type RootMutationTypeCreateDeliveryFailureReportArgs = {
  createDeliveryFailureReport?: InputMaybe<DeliveryFailureReportInput>;
};


export type RootMutationTypeCreateGenericProductArgs = {
  createGenericProduct: CreateGenericProductInput;
};


export type RootMutationTypeCreateGenericProductCategoryArgs = {
  createGenericProductCategory: CreateGenericProductCategoryInput;
};


export type RootMutationTypeCreateHotspotImageArgs = {
  createHotspot: CreateHotspotImageInput;
};


export type RootMutationTypeCreateHotspotLinkArgs = {
  createHotspot: CreateHotspotLinkInput;
};


export type RootMutationTypeCreateHotspotProductArgs = {
  createHotspot: CreateHotspotProductInput;
};


export type RootMutationTypeCreateIdentityUserArgs = {
  createIdentityUser: CreateIdentityUserInput;
};


export type RootMutationTypeCreateIdentityUserPasswordResetLinkArgs = {
  createIdentityUserPasswordResetLink: CreateIdentityUserPasswordResetLinkInput;
};


export type RootMutationTypeCreateLocationArgs = {
  createLocation: CreateLocationInput;
};


export type RootMutationTypeCreateLocationsByImportArgs = {
  createLocationsByImport: CreateLocationsByImportInput;
};


export type RootMutationTypeCreateNewsletterCategoryArgs = {
  input: CreateNewsletterCategoryInput;
};


export type RootMutationTypeCreateOfferCategoryArgs = {
  createOfferCategory: CreateOfferCategoryInput;
};


export type RootMutationTypeCreatePdfArgs = {
  createPdf: CreatePdfInput;
};


export type RootMutationTypeCreateRegionArgs = {
  createRegion: CreateRegionInput;
};


export type RootMutationTypeCreateShopArgs = {
  createShop: CreateShopInput;
};


export type RootMutationTypeCreateShopCardTemplateArgs = {
  createShopCardTemplate: CreateShopCardTemplateInput;
};


export type RootMutationTypeCreateWebsitePageArgs = {
  createWebsitePage: CreateWebsitePageInput;
};


export type RootMutationTypeCreateWebsitePostArgs = {
  createWebsitePost: CreateWebsitePostInput;
};


export type RootMutationTypeDeleteAdsCampaignArgs = {
  deleteAdsCampaign: DeleteAdsCampaignInput;
};


export type RootMutationTypeDeleteAdsCampaignAdvertisementArgs = {
  deleteAdsCampaignAdvertisement: DeleteAdsCampaignAdvertisementInput;
};


export type RootMutationTypeDeleteBrandArgs = {
  deleteBrand: DeleteBrandInput;
};


export type RootMutationTypeDeleteBrandTagArgs = {
  deleteBrandTag: DeleteBrandTagInput;
};


export type RootMutationTypeDeleteCityArgs = {
  deleteCity: DeleteCityInput;
};


export type RootMutationTypeDeleteGenericProductArgs = {
  deleteGenericProduct: DeleteGenericProductInput;
};


export type RootMutationTypeDeleteGenericProductCategoryArgs = {
  deleteGenericProductCategory: DeleteGenericProductCategoryInput;
};


export type RootMutationTypeDeleteHotspotArgs = {
  deleteHotspot: DeleteHotspotInput;
};


export type RootMutationTypeDeleteHotspotsArgs = {
  deleteHotspots: DeleteHotspotsInput;
};


export type RootMutationTypeDeleteIdentityUserArgs = {
  deleteIdentityUser: DeleteIdentityUserInput;
};


export type RootMutationTypeDeleteLocationArgs = {
  deleteLocation: DeleteLocationInput;
};


export type RootMutationTypeDeleteLocationsArgs = {
  deleteLocations: DeleteLocationsInput;
};


export type RootMutationTypeDeleteNewsletterCategoryArgs = {
  input?: InputMaybe<DeleteNewsletterCategoryInput>;
};


export type RootMutationTypeDeleteNewsletterSubscriberArgs = {
  deleteNewsletterSubscriber: DeleteNewsletterSubscriberInput;
};


export type RootMutationTypeDeleteOfferCategoryArgs = {
  deleteOfferCategory: DeleteOfferCategoryInput;
};


export type RootMutationTypeDeleteOfferCategoryTagArgs = {
  deleteOfferCategoryTag: DeleteOfferCategoryTagInput;
};


export type RootMutationTypeDeletePageArgs = {
  deletePage: DeletePageInput;
};


export type RootMutationTypeDeletePdfArgs = {
  deletePdf: DeletePdfInput;
};


export type RootMutationTypeDeleteProductPricesArgs = {
  deleteProductPrices: DeleteProductPricesInput;
};


export type RootMutationTypeDeleteRegionArgs = {
  deleteRegion: DeleteRegionInput;
};


export type RootMutationTypeDeleteRegionsArgs = {
  deleteRegions: DeleteRegionsInput;
};


export type RootMutationTypeDeleteWebsitePageArgs = {
  deleteWebsitePage: DeleteWebsitePageInput;
};


export type RootMutationTypeDetectHotspotsForPageArgs = {
  detectHotspotsForPage: DetectHotspotsForPageInput;
};


export type RootMutationTypeDetectProductHotspotsArgs = {
  detectProductHotspots: DetectProductHotspotsInput;
};


export type RootMutationTypeExportLocationsArgs = {
  exportLocations: ExportLocationsInput;
};


export type RootMutationTypeExportToPdfArgs = {
  exportToPdf: ExportToPdfInput;
};


export type RootMutationTypeImportLocationsArgs = {
  importLocations: ImportLocationsInput;
};


export type RootMutationTypeMigrateBrochureRegionMyshopiArgs = {
  migrateBrochureRegionMyshopi: MigrateBrochureRegionMyshopiInput;
};


export type RootMutationTypePublishMergeRequestArgs = {
  publishMergeRequest: PublishMergeRequestInput;
};


export type RootMutationTypeRejectMergeRequestArgs = {
  rejectMergeRequest: RejectMergeRequestInput;
};


export type RootMutationTypeResetPasswordIdentityUserArgs = {
  resetPasswordIdentityUser: ResetPasswordIdentityUserInput;
};


export type RootMutationTypeSetPasswordIdentityUserArgs = {
  setPasswordIdentityUser: SetPasswordIdentityUserInput;
};


export type RootMutationTypeSortGenericTreeItemsArgs = {
  sortGenericTreeItems: SortGenericTreeItemsInput;
};


export type RootMutationTypeUnsubscribeIdentityUserFromNewslettersArgs = {
  unsubscribeIdentityUserFromNewsletters: UnsubscribeIdentityUserFromNewslettersInput;
};


export type RootMutationTypeUnsubscribeNewsletterSubscriberFromNewslettersArgs = {
  unsubscribeNewsletterSubscriberFromNewsletters: UnsubscribeNewsletterSubscriberFromNewslettersInput;
};


export type RootMutationTypeUpdateAdsCampaignArgs = {
  updateAdsCampaign: UpdateAdsCampaignInput;
};


export type RootMutationTypeUpdateAdsCampaignAdvertisementHtmlEmbedArgs = {
  updateAdsCampaignAdvertisementHtmlEmbed: UpdateAdsCampaignAdvertisementHtmlEmbedInput;
};


export type RootMutationTypeUpdateAdsCampaignAdvertisementImageAdArgs = {
  updateAdsCampaignAdvertisementImageAd: UpdateAdsCampaignAdvertisementImageAdInput;
};


export type RootMutationTypeUpdateAppArgs = {
  updateApp: UpdateAppInput;
};


export type RootMutationTypeUpdateAppLanguageArgs = {
  updateAppLanguage: UpdateAppLanguageInput;
};


export type RootMutationTypeUpdateBrandArgs = {
  updateBrand: UpdateBrandInput;
};


export type RootMutationTypeUpdateBrochureArgs = {
  updateBrochure: UpdateBrochureInput;
};


export type RootMutationTypeUpdateBrochureAssigneeArgs = {
  updateBrochureAssignee: UpdateBrochureAssigneeInput;
};


export type RootMutationTypeUpdateBrochurePositionArgs = {
  updateBrochurePosition: UpdateBrochurePositionInput;
};


export type RootMutationTypeUpdateBrochureStateArgs = {
  updateBrochureState: UpdateBrochureStateInput;
};


export type RootMutationTypeUpdateCategoryArgs = {
  updateCategory: UpdateCategoryInput;
};


export type RootMutationTypeUpdateCityArgs = {
  updateCity: UpdateCityInput;
};


export type RootMutationTypeUpdateCurrentUserArgs = {
  updateCurrentUser: UpdateCurrentUserInput;
};


export type RootMutationTypeUpdateCustomerClientArgs = {
  updateCustomerClient: UpdateCustomerClientInput;
};


export type RootMutationTypeUpdateGenericProductArgs = {
  updateGenericProduct: UpdateGenericProductInput;
};


export type RootMutationTypeUpdateGenericProductCategoryArgs = {
  updateGenericProductCategory: UpdateGenericProductCategoryInput;
};


export type RootMutationTypeUpdateHotspotImageArgs = {
  updateHotspot: UpdateHotspotImageInput;
};


export type RootMutationTypeUpdateHotspotLinkArgs = {
  updateHotspot: UpdateHotspotLinkInput;
};


export type RootMutationTypeUpdateHotspotProductArgs = {
  updateHotspot: UpdateHotspotProductInput;
};


export type RootMutationTypeUpdateIdentityUserArgs = {
  updateIdentityUser: UpdateIdentityUserInput;
};


export type RootMutationTypeUpdateLocationArgs = {
  updateLocation: UpdateLocationInput;
};


export type RootMutationTypeUpdateNewsletterCategoryArgs = {
  input: UpdateNewsletterCategoryInput;
};


export type RootMutationTypeUpdateOfferCategoryArgs = {
  updateOfferCategory: UpdateOfferCategoryInput;
};


export type RootMutationTypeUpdateRegionArgs = {
  updateRegion: UpdateRegionInput;
};


export type RootMutationTypeUpdateShopArgs = {
  updateShop: UpdateShopInput;
};


export type RootMutationTypeUpdateShopCardTemplateArgs = {
  updateShopCardTemplate: UpdateShopCardTemplateInput;
};


export type RootMutationTypeUpdateWebsitePageArgs = {
  updateWebsitePage: UpdateWebsitePageInput;
};


export type RootMutationTypeUpdateWebsitePostArgs = {
  updateWebsitePost: UpdateWebsitePostInput;
};


export type RootMutationTypeUpsertBrochureCityPositionArgs = {
  upsertBrochureCityPosition: UpsertBrochureCityPositionInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** A list of brochures for the brochures statistics management page filtered by published date, shop/category ids, and time step (day/week/month). */
  adminBrochureReads?: Maybe<Array<Maybe<AdminBrochureReadEntity>>>;
  adminShop?: Maybe<AdminShopEntity>;
  adminShops: PaginatedAdminShops;
  /** A list of ads for the dashboard statistics overview page filtered by active time range and time step (day/week/month). */
  adsAdvertisementStatisticsOverview?: Maybe<AdsAdvertisementStatisticsOverviewListResponse>;
  /** Get an ads_campaign. */
  adsCampaign?: Maybe<AdsCampaignEntity>;
  /** Retrieve a single ads_advertisement's data. */
  adsCampaignAdvertisement?: Maybe<AdsAdvertisementEntity>;
  /** A list of ads_advertisements by AdsCampaign. */
  adsCampaignAdvertisements: PaginatedAdsAdvertisements;
  /**
   * Used in the create campaign form: based on the input arguments feasible values are returned.
   *     See the return type for possible values.
   */
  adsCampaignCreateForm: AdsCampaignCreateFormEntity;
  /** A list of ads_campaigns. */
  adsCampaigns: PaginatedAdsCampaigns;
  app: AppEntity;
  /** Retrieve a single app language. */
  appLanguage?: Maybe<AppLanguageEntity>;
  /** A list of app languages. */
  appLanguages?: Maybe<Array<Maybe<AppLanguageEntity>>>;
  /** A list of app users: consumer accounts and guest newsletter subscribers. */
  appUsers?: Maybe<PaginatedAppUsers>;
  /** Retrieve a single brand's data. */
  brand?: Maybe<BrandEntity>;
  /** A list of brands. */
  brands?: Maybe<PaginatedBrands>;
  /** Get brochure */
  brochure?: Maybe<BrochureEntity>;
  /** A list of brochure assignee users. */
  brochureAssignees: PaginatedIdentityUsers;
  /** Get the number of brochures per state */
  brochureCounters: Array<BrochureStateCount>;
  /** A list of brochure_logs. */
  brochureLogs: PaginatedBrochureLogs;
  /** Get brochure_region */
  brochureRegion?: Maybe<BrochureRegionEntity>;
  /** A list of brochure_regions. */
  brochureRegions?: Maybe<Array<Maybe<BrochureRegionEntity>>>;
  /** Brochure state transitions: list possible states from the current state */
  brochureStateTransitions: BrochureStateTransitions;
  /** Brochure statistics detail. */
  brochureStatistic?: Maybe<BrochureDetailStatiticsEntity>;
  /** A list of brochures. */
  brochures: PaginatedBrochures;
  /** A list of brochures for the brochures pages statistics page filtered by published date. */
  brochuresPagesStatistics?: Maybe<Array<Maybe<BrochurePagesStatisticsEntity>>>;
  /** A list of brochures for the brochures reads statistics page filtered by published date. */
  brochuresReadsStatistics?: Maybe<Array<Maybe<BrochureReadStatisticsEntity>>>;
  /** A list of brochures for the dashboard statistics overview page filtered by published date and time step (day/week/month). */
  brochuresStatisticsOverview?: Maybe<BrochuresStatisticsOverviewListResponse>;
  /** A list of categories. */
  categories?: Maybe<Array<Maybe<CategoryEntity>>>;
  category?: Maybe<CategoryEntity>;
  /** A list of cities. */
  cities?: Maybe<PaginatedCities>;
  /** Retrieve a single city's data. */
  city?: Maybe<CityEntity>;
  /** A list of allowed customer client features */
  clientPermissions: Array<CustomerClientPermission>;
  /** Retrieve a single customer_client's data. */
  customerClient: CustomerClientEntity;
  /** A list of customer_clients. */
  customerClients: PaginatedCustomerClients;
  /** A single generic product. */
  genericProduct?: Maybe<GenericProductEntity>;
  /** A single generic product category */
  genericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** A list of generic products. */
  genericProducts: Array<GenericProductEntity>;
  /** A mixed, paginated list of generic products and categories sorted by sort index. */
  genericTreeItems: PaginatedGenericTreeItems;
  /** Retrieve a single hotspot's data. */
  hotspot?: Maybe<HotspotEntity>;
  /** A list of hotspots. */
  hotspots?: Maybe<Array<Maybe<HotspotEntity>>>;
  /** A list of statistics per hotspot of the specified brochure. The statistics are based on the hotspots BigQuery table. See the developer handoff for more information. */
  hotspotsStatistics: Array<HotspotStatistics>;
  /** Retrieve a single identity_user's data. */
  identityUser?: Maybe<IdentityUserEntity>;
  /** A list of identity_users. */
  identityUsers?: Maybe<PaginatedIdentityUsers>;
  /** Retrieve a single language's data. */
  language?: Maybe<LanguageEntity>;
  /** A list of languages. */
  languages?: Maybe<Array<Maybe<LanguageEntity>>>;
  /** A single location */
  location?: Maybe<LocationEntity>;
  me?: Maybe<CurrentUser>;
  /** Merge request details including differences of pages and hotspots */
  mergeRequest?: Maybe<MergeRequestDetails>;
  /** A list of merge_requests. */
  mergeRequests: Array<MergeRequestEntity>;
  myshopiShopBrochures: PaginatedBrochures;
  newsletterCategories: Array<NewsletterCategoryEntity>;
  newsletterCategory?: Maybe<NewsletterCategoryEntity>;
  newsletterSubscribers?: Maybe<PaginatedNewsletterSubscribers>;
  /** A list of offer_categories. */
  offerCategories?: Maybe<PaginatedOfferCategories>;
  /** Retrieve a single offer_category's data. */
  offerCategory?: Maybe<OfferCategoryEntity>;
  offerCategoryTagSuggestions: Array<OfferCategoryTagEntity>;
  /** Get an offer suggestion for a hotspot, or for an area on a page. */
  offerOcrSuggestion?: Maybe<OfferOcrSuggestion>;
  /** Retrieve a single page's data. */
  page?: Maybe<PageEntity>;
  /** A list of pages. */
  pages?: Maybe<Array<Maybe<PageEntity>>>;
  /** Paginated pages with hotspots. */
  pagesWithHotspots: PaginatedPagesWithHotspots;
  /** Get a parser class that should be able to parse the input url. Null if none was found. */
  parserClassByUrl?: Maybe<ParserClasses>;
  /**
   * Get the parser class and url that was used to parse the brochure.
   *     Can be used to create new versions and prefill forms.
   */
  parserParameters: ParserParameters;
  /** Whether any hotspot/page/product/vision_cache post processing job is running */
  postProcessingStatus: PostProcessingStatus;
  /** A list of brochures as seen by users */
  publicBrochures: PaginatedBrochures;
  /** Retrieve a single region. */
  region?: Maybe<RegionEntity>;
  /** A list of regions. */
  regions: Array<RegionEntity>;
  /** Daily session time for a user given a start and end date. */
  sessions: Array<SessionStatistic>;
  /** Retrieve a single shop's basic information. */
  shop?: Maybe<ShopEntity>;
  /** Retrieve a single shop_card_template's data. */
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  /** A list of shop_card_templates. */
  shopCardTemplates: PaginatedShopCardTemplates;
  /** A list of shops. */
  shops?: Maybe<PaginatedShops>;
  /** Daily tag statistics for a user given a start and end date. */
  tagStatistics: Array<TagStatistic>;
  /** Tag statistics of all users given a start and end date. */
  tagStatisticsOverview: TagStatisticsOverview;
  /** A list of tagging users. */
  taggingUsers?: Maybe<PaginatedIdentityUsers>;
  /** Get a page. */
  websitePage?: Maybe<WebsitePageEntity>;
  /** A list of website_pages. Mainly used to retrieve the blog posts. */
  websitePages?: Maybe<PaginatedWebsitePages>;
};


export type RootQueryTypeAdminBrochureReadsArgs = {
  adminBrochureReads: AdminBrochureReadsInput;
};


export type RootQueryTypeAdminShopArgs = {
  adminShop: AdminShopInput;
};


export type RootQueryTypeAdminShopsArgs = {
  adminShops: AdminShopsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAdsAdvertisementStatisticsOverviewArgs = {
  adsAdvertisement: AdsAdvertisementStatisticsOverviewInput;
};


export type RootQueryTypeAdsCampaignArgs = {
  adsCampaign: AdsCampaignInput;
};


export type RootQueryTypeAdsCampaignAdvertisementArgs = {
  adsCampaignAdvertisement: AdsCampaignAdvertisementInput;
};


export type RootQueryTypeAdsCampaignAdvertisementsArgs = {
  adsCampaignAdvertisements: AdsCampaignAdvertisementsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAdsCampaignCreateFormArgs = {
  adsCampaignCreateForm: AdsCampaignCreateFormInput;
};


export type RootQueryTypeAdsCampaignsArgs = {
  adsCampaigns: AdsCampaignsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAppLanguageArgs = {
  appLanguage: AppLanguageInput;
};


export type RootQueryTypeAppUsersArgs = {
  appUsers: AppUsersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrandArgs = {
  brand: BrandInput;
};


export type RootQueryTypeBrandsArgs = {
  brands: BrandsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrochureArgs = {
  brochure: BrochureInput;
};


export type RootQueryTypeBrochureAssigneesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrochureCountersArgs = {
  brochureCounters: BrochureCountersInput;
};


export type RootQueryTypeBrochureLogsArgs = {
  brochureLogs: BrochureLogsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeBrochureRegionArgs = {
  brochureRegion: BrochureRegionInput;
};


export type RootQueryTypeBrochureRegionsArgs = {
  brochureRegions: BrochureRegionsInput;
};


export type RootQueryTypeBrochureStateTransitionsArgs = {
  brochureStateTransitions: BrochureStateTransitionsInput;
};


export type RootQueryTypeBrochureStatisticArgs = {
  brochure: BrochureStatisticsInput;
};


export type RootQueryTypeBrochuresArgs = {
  brochures: BrochuresInput;
  pagination: PaginationInput;
};


export type RootQueryTypeBrochuresPagesStatisticsArgs = {
  brochures: BrochuresPagesStatisticsInput;
};


export type RootQueryTypeBrochuresReadsStatisticsArgs = {
  brochures: BrochuresReadsStatisticsInput;
};


export type RootQueryTypeBrochuresStatisticsOverviewArgs = {
  brochures: BrochuresStatisticsOverviewInput;
};


export type RootQueryTypeCategoriesArgs = {
  categories?: InputMaybe<CategoriesInput>;
};


export type RootQueryTypeCategoryArgs = {
  category: CategoryInput;
};


export type RootQueryTypeCitiesArgs = {
  cities: CitiesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeCityArgs = {
  city: CityInput;
};


export type RootQueryTypeClientPermissionsArgs = {
  clientPermissions: ClientPermissionsScopeInput;
};


export type RootQueryTypeCustomerClientArgs = {
  customerClient: CustomerClientInput;
};


export type RootQueryTypeCustomerClientsArgs = {
  customerClients: CustomerClientsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGenericProductArgs = {
  genericProduct: GenericProductInput;
};


export type RootQueryTypeGenericProductCategoryArgs = {
  genericProductCategory: GenericProductCategoryInput;
};


export type RootQueryTypeGenericProductsArgs = {
  genericProducts: GenericProductsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGenericTreeItemsArgs = {
  genericTreeItems: GenericTreeItemsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeHotspotArgs = {
  hotspot: HotspotInput;
};


export type RootQueryTypeHotspotsArgs = {
  hotspots: HotspotsInput;
};


export type RootQueryTypeHotspotsStatisticsArgs = {
  hotspotsStatistics: HotspotsStatisticsInput;
};


export type RootQueryTypeIdentityUserArgs = {
  identityUser: IdentityUserInput;
};


export type RootQueryTypeIdentityUsersArgs = {
  identityUsers: IdentityUsersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeLanguageArgs = {
  language: LanguageInput;
};


export type RootQueryTypeLocationArgs = {
  location: LocationInput;
};


export type RootQueryTypeMergeRequestArgs = {
  mergeRequest: MergeRequestInput;
};


export type RootQueryTypeMergeRequestsArgs = {
  mergeRequests: MergeRequestsInput;
};


export type RootQueryTypeMyshopiShopBrochuresArgs = {
  myshopiShopBrochures: MyshopiShopBrochuresInput;
  pagination: PaginationInput;
};


export type RootQueryTypeNewsletterCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNewsletterSubscribersArgs = {
  pagination: PaginationInput;
  updatedSince?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOfferCategoriesArgs = {
  offerCategories: OfferCategoriesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeOfferCategoryArgs = {
  offerCategory: OfferCategoryInput;
};


export type RootQueryTypeOfferCategoryTagSuggestionsArgs = {
  offerCategoryTagSuggestions: OfferCategoryTagSuggestionsInput;
};


export type RootQueryTypeOfferOcrSuggestionArgs = {
  hotspot: OfferOcrSuggestionHotspotInput;
  processor: OfferOcrSuggestionProcessor;
};


export type RootQueryTypePageArgs = {
  page: PageInput;
};


export type RootQueryTypePagesArgs = {
  pages: PagesInput;
};


export type RootQueryTypePagesWithHotspotsArgs = {
  pagesWithHotspots: PagesWithHotspotsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeParserClassByUrlArgs = {
  parserClassByUrl: ParserClassByUrlInput;
};


export type RootQueryTypeParserParametersArgs = {
  parserParameters: ParserParametersInput;
};


export type RootQueryTypePostProcessingStatusArgs = {
  postProcessingStatus: PostProcessingStatusInput;
};


export type RootQueryTypePublicBrochuresArgs = {
  cityId?: InputMaybe<Scalars['ID']['input']>;
  pagination: PaginationInput;
  publicBrochures: PublicBrochuresInput;
};


export type RootQueryTypeRegionArgs = {
  region: RegionInput;
};


export type RootQueryTypeRegionsArgs = {
  regions: RegionsInput;
};


export type RootQueryTypeSessionsArgs = {
  sessions: SessionsInput;
};


export type RootQueryTypeShopArgs = {
  shop: ShopInput;
};


export type RootQueryTypeShopCardTemplateArgs = {
  shopCardTemplate: ShopCardTemplateInput;
};


export type RootQueryTypeShopCardTemplatesArgs = {
  pagination: PaginationInput;
  shopCardTemplates: ShopCardTemplatesInput;
};


export type RootQueryTypeShopsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  shops: ShopsInput;
};


export type RootQueryTypeTagStatisticsArgs = {
  tagStatistics: TagStatisticsInput;
};


export type RootQueryTypeTagStatisticsOverviewArgs = {
  tagStatisticsOverview: TagStatisticsOverviewInput;
};


export type RootQueryTypeTaggingUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  taggingUsers: TaggingUsersInput;
};


export type RootQueryTypeWebsitePageArgs = {
  websitePage: WebsitePageInput;
};


export type RootQueryTypeWebsitePagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  websitePages: WebsitePagesInput;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** BrochureLog messages are received here. */
  brochureLogAdded: BrochureLogEntity;
  locationImported: ImportedLocationEntity;
  /** Pdf messages are received here. Those messages are produced by the Cloud Function while extracting the PDF. */
  pdfMessageAdded: PdfMessageEntity;
};


export type RootSubscriptionTypeBrochureLogAddedArgs = {
  brochureId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeLocationImportedArgs = {
  shopId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePdfMessageAddedArgs = {
  pdfId: Scalars['ID']['input'];
};

export type SessionStatistic = {
  __typename?: 'SessionStatistic';
  totalSessionTime: Scalars['Float']['output'];
  trackedAt: Scalars['Date']['output'];
};

export type SessionsInput = {
  /** Session time from this date */
  startAt: Scalars['Date']['input'];
  /** Session time until this date */
  stopAt: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};

export type SetPasswordIdentityUserInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum SetPasswordStatus {
  InvalidPassword = 'INVALID_PASSWORD',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type ShopCardTemplateEntity = {
  __typename?: 'ShopCardTemplateEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shops: Array<ShopEntity>;
  status: ShopCardTemplateStatus;
};


export type ShopCardTemplateEntityFileUrlArgs = {
  version: ShopCardTemplateImageVersion;
};

export enum ShopCardTemplateImageVersion {
  Medium = 'MEDIUM'
}

export type ShopCardTemplateInput = {
  shopCardTemplateId: Scalars['ID']['input'];
};

export enum ShopCardTemplateOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ShopCardTemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ShopCardTemplatesInput = {
  orderBy: ShopCardTemplateOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ShopCardTemplateStatus>>;
};

export type ShopDescriptionEntity = {
  __typename?: 'ShopDescriptionEntity';
  description?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  titleMain?: Maybe<Scalars['String']['output']>;
  titleSecondary?: Maybe<Scalars['String']['output']>;
};

export type ShopDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  titleMain?: InputMaybe<Scalars['String']['input']>;
  titleSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type ShopEntity = {
  __typename?: 'ShopEntity';
  customerClient?: Maybe<CustomerClientEntity>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type ShopEntityFileUrlArgs = {
  version: ShopFileVersion;
};

export enum ShopFileVersion {
  Small = 'SMALL'
}

export type ShopInput = {
  shopId: Scalars['ID']['input'];
};

export enum ShopOrderBy {
  NameAtAsc = 'NAME_AT_ASC',
  NameAtDesc = 'NAME_AT_DESC'
}

export type ShopsInput = {
  clientScope?: InputMaybe<CustomerClientFeature>;
  orderBy: ShopOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SortGenericTreeItemInput = {
  id: Scalars['ID']['input'];
  sortIndex: Scalars['Float']['input'];
};

export type SortGenericTreeItemsInput = {
  items: Array<SortGenericTreeItemInput>;
  /**
   * The parent category whose children to sort.
   *     Use the zero GUID (00000000-0000-0000-0000-000000000000) for root categories.
   */
  parentId: Scalars['ID']['input'];
};

export type StateBrochureLog = BrochureLogEntity & {
  __typename?: 'StateBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export type StatisticsMap = {
  __typename?: 'StatisticsMap';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type TagStatistic = {
  __typename?: 'TagStatistic';
  taggedAt: Scalars['Date']['output'];
  totalTagged: Scalars['Int']['output'];
};

export type TagStatisticsInput = {
  /** Tag statistics that are created from this date */
  startAt: Scalars['Date']['input'];
  /** Tag statistics that are created until this date */
  stopAt: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};

export type TagStatisticsOverview = {
  __typename?: 'TagStatisticsOverview';
  /** This field represents the amount of tag statistics per hotspot. */
  tagStatisticsPerHotspot?: Maybe<Scalars['Float']['output']>;
  /** This field represents the time the user has been active in the dashboard. */
  totalSessionTime: Scalars['Float']['output'];
  /** An overview of the total amount of tagged hotspots per user. */
  userTagStatistics: Array<UserTagStatistic>;
};

export type TagStatisticsOverviewInput = {
  /** Tag statistics that are created from this date */
  startAt: Scalars['Date']['input'];
  /** Tag statistics that are created until this date */
  stopAt: Scalars['Date']['input'];
};

export enum TaggingStrategy {
  /** Gemini */
  GeminiTagger = 'GEMINI_TAGGER'
}

export type TaggingUsersInput = {
  orderBy: IdentityUserOrderBy;
};

export enum TimeStepEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type TransitionState = {
  __typename?: 'TransitionState';
  state: BrochureState;
  title: Scalars['String']['output'];
};

export type UnsubscribeIdentityUserFromNewslettersInput = {
  id: Scalars['ID']['input'];
};

export type UnsubscribeNewsletterSubscriberFromNewslettersInput = {
  id: Scalars['ID']['input'];
};

export type UpdateAdsCampaignAdvertisementHtmlEmbedInput = {
  adType?: InputMaybe<AdType>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  displayAt?: InputMaybe<AdDisplayAt>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  platformType?: InputMaybe<AdPlatformType>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<AdStatusV2>;
  targetType?: InputMaybe<AdTargetType>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdsCampaignAdvertisementImageAdInput = {
  adType?: InputMaybe<AdType>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  displayAt?: InputMaybe<AdDisplayAt>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  platformType?: InputMaybe<AdPlatformType>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<AdStatusV2>;
  targetType?: InputMaybe<AdTargetType>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdsCampaignInput = {
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AdsCampaignStatus>;
  stopAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAppInput = {
  geminiBrandAndOfferStrategy?: InputMaybe<GeminiBrandAndOfferStrategy>;
  geminiTaggingPrompt?: InputMaybe<Scalars['String']['input']>;
  taggingStrategy?: InputMaybe<TaggingStrategy>;
};

export type UpdateAppLanguageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrandInput = {
  brandTags?: InputMaybe<Array<InputMaybe<UpdateBrandTagInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BrandStatus>;
};

export type UpdateBrandTagInput = {
  /** Add id to update/keep existing tags and set null for new tags */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateBrochureAssigneeInput = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UpdateBrochureAssigneeStatus {
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type UpdateBrochureInput = {
  /** If the admin input fields are present then we will authorize the current user. */
  adminFields?: InputMaybe<AdminFields>;
  generalFields: GeneralFields;
  id: Scalars['ID']['input'];
};

export type UpdateBrochurePositionInput = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  positionFrozenTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateBrochureState = {
  __typename?: 'UpdateBrochureState';
  status: UpdateBrochureStateStatus;
};

export type UpdateBrochureStateInput = {
  id: Scalars['ID']['input'];
  state: BrochureState;
};

export enum UpdateBrochureStateStatus {
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export enum UpdateBrochureStatus {
  Failed = 'FAILED',
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type UpdateCategoryInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  titleMain?: InputMaybe<Scalars['String']['input']>;
  titleSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCityInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCurrentUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateCustomerClientInput = {
  features?: InputMaybe<Array<CustomerClientFeature>>;
  id: Scalars['ID']['input'];
  identityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateGenericProductCategoryInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<Array<GenericProductCategoryTranslationInput>>;
};

export type UpdateGenericProductInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<Array<GenericProductTranslationInput>>;
};

export type UpdateHotspotImageInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateHotspotLinkInput = {
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateHotspotProductInput = {
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  productTag: ProductInput;
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateIdentityUserInput = {
  cityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<IdentityUserRole>>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsletterCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferCategoryInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerCategoryBlacklistTags?: InputMaybe<Array<UpdateOfferCategoryTagInput>>;
  offerCategoryTags?: InputMaybe<Array<UpdateOfferCategoryTagInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  shopCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOfferCategoryTagInput = {
  /** Add id to update/keep existing tags and set null for new tags */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateRegionInput = {
  name: Scalars['String']['input'];
  regionId: Scalars['ID']['input'];
};

export type UpdateShopCardTemplateInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ShopCardTemplateStatus>;
};

export type UpdateShopInput = {
  autoParserSlugFr?: InputMaybe<Scalars['String']['input']>;
  autoParserSlugNl?: InputMaybe<Scalars['String']['input']>;
  autoParserType?: InputMaybe<AutoParserType>;
  customerClientId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  geminiTaggingPrompt?: InputMaybe<Scalars['String']['input']>;
  hotspotMode?: InputMaybe<HotspotMode>;
  id: Scalars['ID']['input'];
  lastPage?: InputMaybe<Scalars['Boolean']['input']>;
  localBrochures?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwriteUtms?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  removedFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** The categories for which the brochures in the shop can be shown at the end of a brochure after the last page. */
  shopAfterpage?: InputMaybe<Array<Scalars['ID']['input']>>;
  shopCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  shopDescriptions?: InputMaybe<Array<ShopDescriptionInput>>;
  shopKeywords?: InputMaybe<Scalars['String']['input']>;
  /** The categories for which brochures in the shop can be shown as the top of a brochure stack. */
  shopToplevel?: InputMaybe<Array<Scalars['ID']['input']>>;
  showAds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWebsitePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  contentQuestionsAnswers?: InputMaybe<Array<WebsitePageQuestionAnswerInput>>;
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  positionInFooter?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleQuestionsAnswers?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWebsitePostInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertBrochureCityPositionInput = {
  brochureId: Scalars['ID']['input'];
  cityId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTagStatistic = {
  __typename?: 'UserTagStatistic';
  fullName: Scalars['String']['output'];
  totalSessionTime: Scalars['Float']['output'];
  totalTagged: Scalars['Int']['output'];
};

export type VisionBlock = {
  __typename?: 'VisionBlock';
  confidence?: Maybe<Scalars['Float']['output']>;
  paragraphs: Array<VisionParagraph>;
};

export type VisionParagraph = {
  __typename?: 'VisionParagraph';
  brands: Array<BrandEntity>;
  confidence?: Maybe<Scalars['Float']['output']>;
  offerCategories: Array<OfferCategoryEntity>;
  text: Scalars['String']['output'];
};

export type WebsitePageEntity = {
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  translationSetId?: Maybe<Scalars['ID']['output']>;
};

export enum WebsitePageFileVersion {
  Medium = 'MEDIUM'
}

export type WebsitePageInput = {
  id: Scalars['ID']['input'];
};

export enum WebsitePageOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  PositionInFooterAsc = 'POSITION_IN_FOOTER_ASC',
  PositionInFooterDesc = 'POSITION_IN_FOOTER_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export type WebsitePagePage = WebsitePageEntity & {
  __typename?: 'WebsitePagePage';
  content?: Maybe<Scalars['String']['output']>;
  contentBlocks: Array<Scalars['String']['output']>;
  contentQuestionsAnswers: Array<WebsitePageQuestionAnswer>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  positionInFooter?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleQuestionsAnswers?: Maybe<Scalars['String']['output']>;
  translationSetId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<IdentityUserEntity>;
};

export type WebsitePagePost = WebsitePageEntity & {
  __typename?: 'WebsitePagePost';
  categories: Array<CategoryEntity>;
  content: Scalars['String']['output'];
  coverImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  translationSetId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<IdentityUserEntity>;
};


export type WebsitePagePostCoverImageArgs = {
  version: WebsitePageFileVersion;
};

export type WebsitePageQuestionAnswer = {
  __typename?: 'WebsitePageQuestionAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type WebsitePageQuestionAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export enum WebsitePageType {
  Page = 'PAGE',
  Post = 'POST'
}

export type WebsitePagesInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: WebsitePageOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WebsitePageType>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type AdminShopDetailFragment = { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> };

export type AdminShopOverviewFragment = { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, radius: number, removedFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, locations: Array<{ __typename?: 'LocationEntity', id: string, name: string }>, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> };

export type AppLanguageDetailFragment = { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } };

export type AppLanguageOverviewFragment = { __typename?: 'AppLanguageEntity', id: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } };

export type BrochureOverviewFragment = { __typename?: 'BrochureEntity', id: string, name: string, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null };

export type CategoryDetailFragment = { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } };

export type CategoryOverviewFragment = { __typename?: 'CategoryEntity', id: string, name?: string | null };

export type CityDetailFragment = { __typename?: 'CityEntity', id: string, name: string, position?: number | null };

export type CityOverviewFragment = { __typename?: 'CityEntity', id: string, name: string };

export type CustomerClientOverviewFragment = { __typename?: 'CustomerClientEntity', id: string, name: string };

export type GenericProductCategoryDetailFragment = { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> };

export type GenericProductDetailFragment = { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> };

type GenericProductOverview_GenericProductCategoryEntity_Fragment = { __typename: 'GenericProductCategoryEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> };

type GenericProductOverview_GenericProductEntity_Fragment = { __typename: 'GenericProductEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> };

export type GenericProductOverviewFragment = GenericProductOverview_GenericProductCategoryEntity_Fragment | GenericProductOverview_GenericProductEntity_Fragment;

export type ShopCardTemplateDetailFragment = { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> };

export type ShopLocationFragment = { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } };

export type UserDetailFragment = { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> };

export type UserOverviewFragment = { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string };

export type ApprovedAtHotspotFieldFragment = { __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } };

export type BrochureRegionDifferenceFragment = { __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> };

type Hotspot_HotspotImageEntity_Fragment = { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

type Hotspot_HotspotLinkEntity_Fragment = { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

type Hotspot_HotspotProductEntity_Fragment = { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } };

export type HotspotFragment = Hotspot_HotspotImageEntity_Fragment | Hotspot_HotspotLinkEntity_Fragment | Hotspot_HotspotProductEntity_Fragment;

export type HotspotImageFragment = { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

export type HotspotLinkFragment = { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

export type HotspotProductFragment = { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } };

export type MergeRequestFragment = { __typename?: 'MergeRequestDetails', mergeRequest: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } }, brochureRegions: Array<{ __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> }> };

export type PageWithHotspotsFragment = { __typename?: 'PageEntity', id: string, index: number, fileUrl?: string | null, hotspots?: Array<{ __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } }> | null };

export type PaginationFragment = { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number };

export type ApproveHotspotFieldsMutationVariables = Exact<{
  approveHotspotFields: ApproveHotspotFieldsInput;
}>;


export type ApproveHotspotFieldsMutation = { __typename?: 'RootMutationType', approveHotspotFields?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type ApproveMergeRequestAsNewMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type ApproveMergeRequestAsNewMutation = { __typename?: 'RootMutationType', approveMergeRequestAsNew: { __typename?: 'ApproveMergeRequestAsNew', status: MutatedStatus } };

export type ApproveMergeRequestAsUpdateMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
  pageFilters?: InputMaybe<Array<PageFilter> | PageFilter>;
}>;


export type ApproveMergeRequestAsUpdateMutation = { __typename?: 'RootMutationType', approveMergeRequestAsUpdate: { __typename?: 'ApproveMergeRequestAsUpdate', status: MutatedStatus } };

export type ChangePasswordIdentityUserMutationVariables = Exact<{
  changePasswordIdentityUser: ChangePasswordIdentityUserInput;
}>;


export type ChangePasswordIdentityUserMutation = { __typename?: 'RootMutationType', changePasswordIdentityUser?: { __typename?: 'MutatedChangePasswordIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string } | null } | null };

export type ConvertLinkHotspotsToProductHotspotsMutationVariables = Exact<{
  convertHotspotsInput: ConvertHotspotsInput;
}>;


export type ConvertLinkHotspotsToProductHotspotsMutation = { __typename?: 'RootMutationType', convertLinkHotspotsToProductHotspots: { __typename?: 'ConvertLinkHotspotsStatusEntity', status: MutatedStatus } };

export type CopyBrochureRegionMutationVariables = Exact<{
  copyBrochureRegionInput: CopyBrochureRegionInput;
}>;


export type CopyBrochureRegionMutation = { __typename?: 'RootMutationType', copyBrochureRegion: { __typename?: 'CopyBrochureRegionStatusEntity', status: CopyBrochureRegionStatus } };

export type CopyHotspotsMutationVariables = Exact<{
  copyHotspotsInput: CopyHotspotsInput;
}>;


export type CopyHotspotsMutation = { __typename?: 'RootMutationType', copyHotspots?: { __typename?: 'CopyHotspotsStatusEntity', status: CopyHotspotsStatus } | null };

export type CreateAdsCampaignMutationVariables = Exact<{
  createAdsCampaign: CreateAdsCampaignInput;
}>;


export type CreateAdsCampaignMutation = { __typename?: 'RootMutationType', createAdsCampaign: { __typename?: 'MutatedCreateAdsCampaign', status?: MutatedStatus | null, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string } | null } };

export type CreateBrandMutationVariables = Exact<{
  createBrandInput: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'RootMutationType', createBrand?: { __typename?: 'BrandEntity', id: string } | null };

export type CreateBrochureExperimentMutationVariables = Exact<{
  input: CreateBrochureExperimentInput;
}>;


export type CreateBrochureExperimentMutation = { __typename?: 'RootMutationType', createBrochureExperiment: { __typename?: 'MutatedCreateBrochureExperiment', status: BrochureExperimentCreateStatus, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', name: string, variantCount: number, brochureExperimentVariants: Array<{ __typename?: 'BrochureExperimentVariantEntity', variantNumber: number, brochureRegions: Array<{ __typename?: 'BrochureRegionEntity', id: string }> }> } | null } };

export type CreateCategoryMutationVariables = Exact<{
  createCategoryInput: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'RootMutationType', createCategory?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type CreateCityMutationVariables = Exact<{
  createCityInput: CreateCityInput;
}>;


export type CreateCityMutation = { __typename?: 'RootMutationType', createCity?: { __typename?: 'CityEntity', id: string } | null };

export type CreateCustomerClientMutationVariables = Exact<{
  createCustomerClientInput: CreateCustomerClientInput;
}>;


export type CreateCustomerClientMutation = { __typename?: 'RootMutationType', createCustomerClient?: { __typename?: 'CustomerClientEntity', id: string } | null };

export type CreateGenericProductMutationVariables = Exact<{
  input: CreateGenericProductInput;
}>;


export type CreateGenericProductMutation = { __typename?: 'RootMutationType', createGenericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type CreateGenericProductCategoryMutationVariables = Exact<{
  input: CreateGenericProductCategoryInput;
}>;


export type CreateGenericProductCategoryMutation = { __typename?: 'RootMutationType', createGenericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type CreateHotspotImageMutationVariables = Exact<{
  createHotspotInput: CreateHotspotImageInput;
}>;


export type CreateHotspotImageMutation = { __typename?: 'RootMutationType', createHotspotImage?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotLinkEntity' } | { __typename?: 'HotspotProductEntity' } | null };

export type CreateHotspotLinkMutationVariables = Exact<{
  createHotspotInput: CreateHotspotLinkInput;
}>;


export type CreateHotspotLinkMutation = { __typename?: 'RootMutationType', createHotspotLink?: { __typename?: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotProductEntity' } | null };

export type CreateHotspotProductMutationVariables = Exact<{
  createHotspotInput: CreateHotspotProductInput;
}>;


export type CreateHotspotProductMutation = { __typename?: 'RootMutationType', createHotspotProduct?: { __typename?: 'HotspotImageEntity' } | { __typename?: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type CreateIdentityUserMutationVariables = Exact<{
  input: CreateIdentityUserInput;
}>;


export type CreateIdentityUserMutation = { __typename?: 'RootMutationType', createIdentityUser?: { __typename?: 'MutatedCreateIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null } | null };

export type CreateIdentityUserPasswordResetLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateIdentityUserPasswordResetLinkMutation = { __typename?: 'RootMutationType', createIdentityUserPasswordResetLink?: { __typename?: 'MutatedCreateIdentityUserPasswordResetLink', url: string } | null };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'RootMutationType', createLocation: { __typename?: 'MutatedLocation', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null } };

export type CreateLocationsByImportMutationVariables = Exact<{
  input: CreateLocationsByImportInput;
}>;


export type CreateLocationsByImportMutation = { __typename?: 'RootMutationType', createLocationsByImport: { __typename?: 'MutatedCreateLocationsByImport', status: MutatedStatus } };

export type CreateOfferCategoryMutationVariables = Exact<{
  createOfferCategoryInput: CreateOfferCategoryInput;
}>;


export type CreateOfferCategoryMutation = { __typename?: 'RootMutationType', createOfferCategory?: { __typename?: 'OfferCategoryEntity', id: string } | null };

export type CreatePdfMutationVariables = Exact<{
  createPdf: CreatePdfInput;
}>;


export type CreatePdfMutation = { __typename?: 'RootMutationType', createPdf?: { __typename?: 'PdfEntity', id: string, uploadUrl: string } | null };

export type CreateBrochureByParserMutationVariables = Exact<{
  createBrochure: CreateBrochureByParserInput;
}>;


export type CreateBrochureByParserMutation = { __typename?: 'RootMutationType', createBrochureByParser: { __typename?: 'CreateBrochureByParser', status: CreateBrochureByParserStatus } };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'RootMutationType', createRegion: { __typename?: 'MutatedRegion', status: MutatedStatus, region?: { __typename: 'RegionEntity', id: string, name: string } | null } };

export type CreateShopMutationVariables = Exact<{
  createShopInput: CreateShopInput;
}>;


export type CreateShopMutation = { __typename?: 'RootMutationType', createShop: { __typename?: 'MutatedShop', status: MutatedStatus, shop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null } };

export type CreateShopCardTemplateMutationVariables = Exact<{
  createShopCardTemplateInput: CreateShopCardTemplateInput;
}>;


export type CreateShopCardTemplateMutation = { __typename?: 'RootMutationType', createShopCardTemplate: { __typename?: 'MutatedCreateShopCardTemplate', status: MutatedStatus, shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null } | null } };

export type CreateWebsitePageMutationVariables = Exact<{
  createWebsitePage: CreateWebsitePageInput;
}>;


export type CreateWebsitePageMutation = { __typename?: 'RootMutationType', createWebsitePage?: { __typename?: 'WebsitePagePage', id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null } | null };

export type CreateWebsitePostMutationVariables = Exact<{
  createWebsitePost: CreateWebsitePostInput;
}>;


export type CreateWebsitePostMutation = { __typename?: 'RootMutationType', createWebsitePost?: { __typename?: 'WebsitePagePost', content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string } | null };

export type DeleteBrandMutationVariables = Exact<{
  deleteBrand: DeleteBrandInput;
}>;


export type DeleteBrandMutation = { __typename?: 'RootMutationType', deleteBrand?: { __typename?: 'MutatedDeleteBrand', status?: MutatedStatus | null } | null };

export type DeleteCityMutationVariables = Exact<{
  deleteCity: DeleteCityInput;
}>;


export type DeleteCityMutation = { __typename?: 'RootMutationType', deleteCity?: { __typename?: 'MutatedDeleteCity', status?: MutatedStatus | null } | null };

export type DeleteGenericProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGenericProductMutation = { __typename?: 'RootMutationType', deleteGenericProduct: { __typename?: 'MutatedDeleteGenericProduct', status?: MutatedStatus | null } };

export type DeleteGenericProductCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGenericProductCategoryMutation = { __typename?: 'RootMutationType', deleteGenericProductCategory: { __typename?: 'MutatedDeleteGenericProductCategory', status?: MutatedStatus | null } };

export type DeleteHotspotMutationVariables = Exact<{
  deleteHotspotInput: DeleteHotspotInput;
}>;


export type DeleteHotspotMutation = { __typename?: 'RootMutationType', deleteHotspot?: { __typename?: 'MutatedDeleteHotspot', status?: MutatedStatus | null } | null };

export type DeleteHotspotsMutationVariables = Exact<{
  deleteHotspots: DeleteHotspotsInput;
}>;


export type DeleteHotspotsMutation = { __typename?: 'RootMutationType', deleteHotspots: { __typename?: 'DeleteHotspotsStatus', status: MutatedStatus } };

export type DeleteIdentityUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIdentityUserMutation = { __typename?: 'RootMutationType', deleteIdentityUser?: { __typename?: 'MutatedDeleteIdentityUser', status?: MutatedStatus | null } | null };

export type DeleteLocationMutationVariables = Exact<{
  deleteLocation: DeleteLocationInput;
}>;


export type DeleteLocationMutation = { __typename?: 'RootMutationType', deleteLocation: { __typename?: 'MutatedDeleteLocation', status: MutatedStatus } };

export type DeleteLocationsMutationVariables = Exact<{
  deleteLocations: DeleteLocationsInput;
}>;


export type DeleteLocationsMutation = { __typename?: 'RootMutationType', deleteLocations: { __typename?: 'MutatedDeleteLocations', status: MutatedStatus } };

export type DeleteNewsletterSubscriberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNewsletterSubscriberMutation = { __typename?: 'RootMutationType', deleteNewsletterSubscriber?: { __typename?: 'MutatedDeleteNewsletterSubscriber', status?: MutatedStatus | null } | null };

export type DeleteOfferCategoryMutationVariables = Exact<{
  deleteOfferCategory: DeleteOfferCategoryInput;
}>;


export type DeleteOfferCategoryMutation = { __typename?: 'RootMutationType', deleteOfferCategory?: { __typename?: 'MutatedDeleteOfferCategory', status: MutatedStatus } | null };

export type DeleteOfferCategoryTagMutationVariables = Exact<{
  input: DeleteOfferCategoryTagInput;
}>;


export type DeleteOfferCategoryTagMutation = { __typename?: 'RootMutationType', deleteOfferCategoryTag: { __typename?: 'MutatedDeleteOfferCategoryTag', status: MutatedStatus } };

export type DeletePageMutationVariables = Exact<{
  deletePage: DeletePageInput;
}>;


export type DeletePageMutation = { __typename?: 'RootMutationType', deletePage: { __typename?: 'MutatedDeletePage', status: DeletePageStatus } };

export type DeleteProductPricesMutationVariables = Exact<{
  deleteProductPrices: DeleteProductPricesInput;
}>;


export type DeleteProductPricesMutation = { __typename?: 'RootMutationType', deleteProductPrices: { __typename?: 'DeleteProductPricesStatus', status: MutatedStatus } };

export type DeleteRegionMutationVariables = Exact<{
  deleteRegion: DeleteRegionInput;
}>;


export type DeleteRegionMutation = { __typename?: 'RootMutationType', deleteRegion: { __typename?: 'MutatedDeleteRegion', status: MutatedStatus } };

export type DeleteRegionsMutationVariables = Exact<{
  deleteRegions: DeleteRegionsInput;
}>;


export type DeleteRegionsMutation = { __typename?: 'RootMutationType', deleteRegions: { __typename?: 'MutatedDeleteRegions', status: MutatedStatus } };

export type DeleteWebsitePageMutationVariables = Exact<{
  deleteWebsitePage: DeleteWebsitePageInput;
}>;


export type DeleteWebsitePageMutation = { __typename?: 'RootMutationType', deleteWebsitePage?: { __typename?: 'MutatedDeleteWebsitePage', status?: MutatedStatus | null } | null };

export type DetectProductHotspotsMutationVariables = Exact<{
  detectProductHotspotsInput: DetectProductHotspotsInput;
}>;


export type DetectProductHotspotsMutation = { __typename?: 'RootMutationType', detectProductHotspots: { __typename?: 'DetectProductHotspotsEntity', status: DetectProductHotspotsState } };

export type DeleteAdsAdvertisementMutationVariables = Exact<{
  deleteAdsCampaignAdvertisement: DeleteAdsCampaignAdvertisementInput;
}>;


export type DeleteAdsAdvertisementMutation = { __typename?: 'RootMutationType', deleteAdsCampaignAdvertisement?: { __typename?: 'MutatedDeleteAdsAdvertisement', status?: MutatedStatus | null } | null };

export type ShopsLocationsCvsLinkMutationVariables = Exact<{
  input: ExportLocationsInput;
}>;


export type ShopsLocationsCvsLinkMutation = { __typename?: 'RootMutationType', exportLocations: { __typename?: 'MutatedExportLocations', fileUrl?: string | null } };

export type ExportToPdfMutationVariables = Exact<{
  exportToPdfInput: ExportToPdfInput;
}>;


export type ExportToPdfMutation = { __typename?: 'RootMutationType', exportToPdf: { __typename?: 'ExportToPdfResponse', status?: MutatedStatus | null } };

export type ImportLocationsMutationVariables = Exact<{
  input: ImportLocationsInput;
}>;


export type ImportLocationsMutation = { __typename?: 'RootMutationType', importLocations: { __typename?: 'MutatedImportLocations', locationCount: number, status: MutatedImportLocationsStatus } };

export type MigrateBrochureRegionMyshopiMutationVariables = Exact<{
  input: MigrateBrochureRegionMyshopiInput;
}>;


export type MigrateBrochureRegionMyshopiMutation = { __typename?: 'RootMutationType', migrateBrochureRegionMyshopi: { __typename?: 'MutatedMigrateBrochureRegionMyshopi', status: MutatedStatus } };

export type PublishMergeRequestMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type PublishMergeRequestMutation = { __typename?: 'RootMutationType', publishMergeRequest: { __typename?: 'MutatedMergeRequest', status: MutatedStatus } };

export type RejectMergeRequestMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type RejectMergeRequestMutation = { __typename?: 'RootMutationType', rejectMergeRequest: { __typename?: 'MutatedMergeRequest', status: MutatedStatus } };

export type ResetPasswordIdentityUserMutationVariables = Exact<{
  resetPasswordIdentityUser: ResetPasswordIdentityUserInput;
}>;


export type ResetPasswordIdentityUserMutation = { __typename?: 'RootMutationType', resetPasswordIdentityUser?: { __typename?: 'MutatedResetPasswordIdentityUser', status?: ResetPasswordStatus | null } | null };

export type SetPasswordIdentityUserMutationVariables = Exact<{
  setPasswordIdentityUser: SetPasswordIdentityUserInput;
}>;


export type SetPasswordIdentityUserMutation = { __typename?: 'RootMutationType', setPasswordIdentityUser?: { __typename?: 'MutatedSetPasswordIdentityUser', status?: SetPasswordStatus | null } | null };

export type SortGenericTreeItemsMutationVariables = Exact<{
  input: SortGenericTreeItemsInput;
}>;


export type SortGenericTreeItemsMutation = { __typename?: 'RootMutationType', sortGenericTreeItems: MutatedStatus };

export type UnsubscribeIdentityUserFromNewslettersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnsubscribeIdentityUserFromNewslettersMutation = { __typename?: 'RootMutationType', unsubscribeIdentityUserFromNewsletters?: { __typename?: 'MutatedUnsubscribeIdentityUserFromNewsletters', status?: MutatedStatus | null } | null };

export type UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnsubscribeNewsletterSubscriberFromNewslettersMutation = { __typename?: 'RootMutationType', unsubscribeNewsletterSubscriberFromNewsletters?: { __typename?: 'MutatedUnsubscribeNewsletterSubscriberFromNewsletters', status?: MutatedStatus | null } | null };

export type UpdateAdsCampaignMutationVariables = Exact<{
  updateAdsCampaignInput: UpdateAdsCampaignInput;
}>;


export type UpdateAdsCampaignMutation = { __typename?: 'RootMutationType', updateAdsCampaign?: { __typename?: 'AdsCampaignEntity', status: AdsCampaignStatus } | null };

export type UpdateAppMutationVariables = Exact<{
  updateApp: UpdateAppInput;
}>;


export type UpdateAppMutation = { __typename?: 'RootMutationType', updateApp?: { __typename?: 'AppEntity', id: string, geminiTaggingPrompt?: string | null, taggingStrategy?: TaggingStrategy | null } | null };

export type UpdateAppLanguageMutationVariables = Exact<{
  updateAppLanguage: UpdateAppLanguageInput;
}>;


export type UpdateAppLanguageMutation = { __typename?: 'RootMutationType', updateAppLanguage?: { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null };

export type UpdateBrandMutationVariables = Exact<{
  updateBrandInput: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'RootMutationType', updateBrand?: { __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, description?: string | null, position?: number | null, slug: string, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', id: string, name: string }> } | null };

export type UpdateBrochureMutationVariables = Exact<{
  updateBrochureInput: UpdateBrochureInput;
}>;


export type UpdateBrochureMutation = { __typename?: 'RootMutationType', updateBrochure: { __typename?: 'MutatedUpdateBrochure', status: UpdateBrochureStatus } };

export type UpdateBrochureAssigneeMutationVariables = Exact<{
  updateBrochureAssigneeInput: UpdateBrochureAssigneeInput;
}>;


export type UpdateBrochureAssigneeMutation = { __typename?: 'RootMutationType', updateBrochureAssignee: { __typename?: 'MutatedUpdateBrochureAssignee', status: UpdateBrochureAssigneeStatus, brochure?: { __typename?: 'BrochureEntity', assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, fileUrl?: string | null } | null } | null } };

export type UpdateBrochurePositionMutationVariables = Exact<{
  input: UpdateBrochurePositionInput;
}>;


export type UpdateBrochurePositionMutation = { __typename?: 'RootMutationType', updateBrochurePosition: { __typename?: 'MutatedUpdateBrochure', status: UpdateBrochureStatus, brochure?: { __typename?: 'BrochureEntity', id: string, position?: number | null, positionFrozenTo?: any | null } | null } };

export type UpdateBrochureStateMutationVariables = Exact<{
  updateBrochureStateInput: UpdateBrochureStateInput;
}>;


export type UpdateBrochureStateMutation = { __typename?: 'RootMutationType', updateBrochureState?: { __typename?: 'UpdateBrochureState', status: UpdateBrochureStateStatus } | null };

export type UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables = Exact<{
  updateAdsCampaignAdvertisementHtmlEmbedInput: UpdateAdsCampaignAdvertisementHtmlEmbedInput;
}>;


export type UpdateAdsCampaignAdvertisementHtmlEmbedMutation = { __typename?: 'RootMutationType', updateAdsCampaignAdvertisementHtmlEmbed?: { __typename?: 'AdsAdvertisementHtmlEmbed', status: AdStatusAll } | { __typename?: 'AdsAdvertisementImage', status: AdStatusAll } | null };

export type UpdateAdsCampaignAdvertisementImageAdMutationVariables = Exact<{
  updateAdsCampaignAdvertisementImageAdInput: UpdateAdsCampaignAdvertisementImageAdInput;
}>;


export type UpdateAdsCampaignAdvertisementImageAdMutation = { __typename?: 'RootMutationType', updateAdsCampaignAdvertisementImageAd?: { __typename?: 'AdsAdvertisementHtmlEmbed', status: AdStatusAll } | { __typename?: 'AdsAdvertisementImage', status: AdStatusAll } | null };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryInput: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'RootMutationType', updateCategory?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type UpdateCityMutationVariables = Exact<{
  updateCityInput: UpdateCityInput;
}>;


export type UpdateCityMutation = { __typename?: 'RootMutationType', updateCity?: { __typename?: 'CityEntity', id: string } | null };

export type UpdateCurrentUserMutationVariables = Exact<{
  updateCurrentUser: UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'RootMutationType', updateCurrentUser?: { __typename?: 'MutatedUpdateCurrentUser', currentUser?: { __typename?: 'CurrentUser', id: string } | null } | null };

export type UpdateCustomerClientMutationVariables = Exact<{
  updateCustomerClientInput: UpdateCustomerClientInput;
}>;


export type UpdateCustomerClientMutation = { __typename?: 'RootMutationType', updateCustomerClient?: { __typename?: 'CustomerClientEntity', id: string } | null };

export type UpdateGenericProductMutationVariables = Exact<{
  input: UpdateGenericProductInput;
}>;


export type UpdateGenericProductMutation = { __typename?: 'RootMutationType', updateGenericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type UpdateGenericProductCategoryMutationVariables = Exact<{
  input: UpdateGenericProductCategoryInput;
}>;


export type UpdateGenericProductCategoryMutation = { __typename?: 'RootMutationType', updateGenericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type UpdateHotspotImageMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotImageInput;
}>;


export type UpdateHotspotImageMutation = { __typename?: 'RootMutationType', updateHotspotImage?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotLinkEntity' } | { __typename?: 'HotspotProductEntity' } | null };

export type UpdateHotspotLinkMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotLinkInput;
}>;


export type UpdateHotspotLinkMutation = { __typename?: 'RootMutationType', updateHotspotLink?: { __typename?: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotProductEntity' } | null };

export type UpdateHotspotProductMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotProductInput;
}>;


export type UpdateHotspotProductMutation = { __typename?: 'RootMutationType', updateHotspotProduct?: { __typename?: 'HotspotImageEntity' } | { __typename?: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type UpdateIdentityUserMutationVariables = Exact<{
  input: UpdateIdentityUserInput;
}>;


export type UpdateIdentityUserMutation = { __typename?: 'RootMutationType', updateIdentityUser?: { __typename?: 'MutatedUpdateIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null } | null };

export type UpdateOfferCategoryMutationVariables = Exact<{
  updateOfferCategoryInput: UpdateOfferCategoryInput;
}>;


export type UpdateOfferCategoryMutation = { __typename?: 'RootMutationType', updateOfferCategory?: { __typename?: 'OfferCategoryEntity', id: string } | null };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'RootMutationType', updateRegion: { __typename?: 'MutatedRegion', status: MutatedStatus, region?: { __typename: 'RegionEntity', id: string, name: string } | null } };

export type UpdateShopMutationVariables = Exact<{
  updateShopInput: UpdateShopInput;
}>;


export type UpdateShopMutation = { __typename?: 'RootMutationType', updateShop: { __typename?: 'MutatedShop', status: MutatedStatus, shop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null } };

export type UpdateShopCardTemplateMutationVariables = Exact<{
  updateShopCardTemplateInput: UpdateShopCardTemplateInput;
}>;


export type UpdateShopCardTemplateMutation = { __typename?: 'RootMutationType', updateShopCardTemplate: { __typename?: 'MutatedUpdateShopCardTemplate', status: MutatedUpdateShopCardTemplateStatus, shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> } | null } };

export type UpdateWebsitePageMutationVariables = Exact<{
  updateWebsitePage: UpdateWebsitePageInput;
}>;


export type UpdateWebsitePageMutation = { __typename?: 'RootMutationType', updateWebsitePage?: { __typename?: 'WebsitePagePage', id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, contentBlocks: Array<string>, titleQuestionsAnswers?: string | null, contentQuestionsAnswers: Array<{ __typename?: 'WebsitePageQuestionAnswer', question: string, answer: string }> } | null };

export type UpdateWebsitePostMutationVariables = Exact<{
  updateWebsitePost: UpdateWebsitePostInput;
}>;


export type UpdateWebsitePostMutation = { __typename?: 'RootMutationType', updateWebsitePost?: { __typename?: 'WebsitePagePost', content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null } | null };

export type UpsertBrochureCityPositionMutationVariables = Exact<{
  input: UpsertBrochureCityPositionInput;
}>;


export type UpsertBrochureCityPositionMutation = { __typename?: 'RootMutationType', upsertBrochureCityPosition: { __typename?: 'MutatedUpsertBrochureCity', status: UpdateBrochureStatus } };

export type UpsertSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type UpsertSessionMutation = { __typename?: 'RootMutationType', upsertSession: { __typename?: 'MutatedUpsertSessionStatus', status: MutatedStatus } };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'RootMutationType', updateLocation?: { __typename?: 'MutatedLocation', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null } | null };

export type BrochureStateQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureStateQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, name: string, state: BrochureState, assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, shop: { __typename?: 'ShopEntity', id: string, name: string, customerClient?: { __typename?: 'CustomerClientEntity', id: string, features: Array<CustomerClientFeature> } | null }, language: { __typename?: 'LanguageEntity', id: string }, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus } | null, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', id: string } | null } | null };

export type BrochureAssigneesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BrochureAssigneesQuery = { __typename?: 'RootQueryType', brochureAssignees: { __typename?: 'PaginatedIdentityUsers', pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null }, entries: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null }> } };

export type BrochureDetailQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureDetailQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, name: string, publishedAt?: any | null, activeFrom?: any | null, position?: number | null, positionFrozenTo?: any | null, expireAfter?: any | null, hotspotMode: HotspotMode, customerLevel?: CustomerLevel | null, utmCampaign?: string | null, utmMedium?: string | null, local: boolean, removedProductsFromSearch: boolean, state: BrochureState, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, shop: { __typename?: 'ShopEntity', id: string, slug: string, name: string } } | null };

export type BrochureLanguageQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureLanguageQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', language: { __typename?: 'LanguageEntity', id: string, name: string } } | null };

export type BrochurePageQueryQueryVariables = Exact<{
  pageInput: PageInput;
  fileVersion: BrochureStatisticsFileVersion;
}>;


export type BrochurePageQueryQuery = { __typename?: 'RootQueryType', page?: { __typename?: 'PageEntity', fileUrl?: string | null, id: string, index: number } | null };

export type BrochurePagesQueryQueryVariables = Exact<{
  pagesInput: PagesInput;
  fileVersion: BrochureStatisticsFileVersion;
}>;


export type BrochurePagesQueryQuery = { __typename?: 'RootQueryType', pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null, id: string, index: number } | null> | null };

export type AdminBrochureReadsQueryVariables = Exact<{
  adminBrochureReads: AdminBrochureReadsInput;
}>;


export type AdminBrochureReadsQuery = { __typename?: 'RootQueryType', adminBrochureReads?: Array<{ __typename?: 'AdminBrochureReadEntity', date: string, totalReads: number, webReads: number, iosReads: number, androidReads: number } | null> | null };

export type BrochureRegionsQueryVariables = Exact<{
  brochureRegionsInput: BrochureRegionsInput;
}>;


export type BrochureRegionsQuery = { __typename?: 'RootQueryType', brochureRegions?: Array<{ __typename?: 'BrochureRegionEntity', id: string, region: { __typename?: 'RegionEntity', id: string, name: string }, brochureExperimentVariant?: { __typename?: 'BrochureExperimentVariantEntity', id: string, variantNumber: number } | null } | null> | null };

export type BrochureStateTransitionsQueryVariables = Exact<{
  brochureStateTransitionsInput: BrochureStateTransitionsInput;
}>;


export type BrochureStateTransitionsQuery = { __typename?: 'RootQueryType', brochureStateTransitions: { __typename?: 'BrochureStateTransitions', status: BrochureTransitionsStatus, transitionStates: Array<{ __typename?: 'TransitionState', state: BrochureState, title: string }>, currentState?: { __typename?: 'TransitionState', state: BrochureState, title: string } | null } };

export type BrochuresQueryQueryVariables = Exact<{
  brochuresInput: BrochuresInput;
  pagination: PaginationInput;
}>;


export type BrochuresQueryQuery = { __typename?: 'RootQueryType', brochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, name: string, publishedAt?: any | null, activeFrom?: any | null, expireAfter?: any | null, position?: number | null, positionFrozenTo?: any | null, shop: { __typename?: 'ShopEntity', id: string, slug: string }, cover?: { __typename?: 'PageEntity', id: string, fileUrl?: string | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', id: string } | null, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdminShopQueryVariables = Exact<{
  input: AdminShopInput;
}>;


export type AdminShopQuery = { __typename?: 'RootQueryType', adminShop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null };

export type AdminShopLocationsQueryVariables = Exact<{
  input: AdminShopInput;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminShopLocationsQuery = { __typename?: 'RootQueryType', adminShop?: { __typename?: 'AdminShopEntity', id: string, locations: Array<{ __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } }> } | null };

export type AdminShopsQueryVariables = Exact<{
  input: AdminShopsInput;
  pagination: PaginationInput;
}>;


export type AdminShopsQuery = { __typename?: 'RootQueryType', adminShops: { __typename?: 'PaginatedAdminShops', entries: Array<{ __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, radius: number, removedFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, locations: Array<{ __typename?: 'LocationEntity', id: string, name: string }>, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdsCampaignQueryVariables = Exact<{
  adsCampaignInput: AdsCampaignInput;
}>;


export type AdsCampaignQuery = { __typename?: 'RootQueryType', adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, languageId: string, name: string, startAt: any, stopAt: any, targetType: AdTargetType, status: AdsCampaignStatus, customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string } } | null };

export type AdsCampaignAdvertisementQueryVariables = Exact<{
  adsCampaignAdvertisementInput: AdsCampaignAdvertisementInput;
}>;


export type AdsCampaignAdvertisementQuery = { __typename?: 'RootQueryType', adsCampaignAdvertisement?: { __typename?: 'AdsAdvertisementHtmlEmbed', content: string, adDimension: AdDimension, id: string, weight: number, impressionsLimit: number, targetType: AdTargetType, platformType: AdPlatformType, adType: AdType, displayAt: AdDisplayAt, displayUrl: string, status: AdStatusAll, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | { __typename?: 'AdsAdvertisementImage', fileUrl?: string | null, adDimension: AdDimension, id: string, weight: number, impressionsLimit: number, targetType: AdTargetType, platformType: AdPlatformType, adType: AdType, displayAt: AdDisplayAt, displayUrl: string, status: AdStatusAll, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | null };

export type AdsCampaignAdvertisementsQueryVariables = Exact<{
  adsCampaignAdvertisementsInput: AdsCampaignAdvertisementsInput;
  pagination: PaginationInput;
}>;


export type AdsCampaignAdvertisementsQuery = { __typename?: 'RootQueryType', adsCampaignAdvertisements: { __typename?: 'PaginatedAdsAdvertisements', entries: Array<{ __typename?: 'AdsAdvertisementHtmlEmbed', adType: AdType, displayAt: AdDisplayAt, id: string, impressionsLimit: number, platformType: AdPlatformType, status: AdStatusAll, weight: number, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | { __typename?: 'AdsAdvertisementImage', adType: AdType, displayAt: AdDisplayAt, id: string, impressionsLimit: number, platformType: AdPlatformType, status: AdStatusAll, weight: number, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdsCampaignCreateFormQueryVariables = Exact<{
  adsCampaignCreateFormInput: AdsCampaignCreateFormInput;
}>;


export type AdsCampaignCreateFormQuery = { __typename?: 'RootQueryType', adsCampaignCreateForm: { __typename?: 'AdsCampaignCreateFormEntity', adDimensions: Array<AdDimension>, displayAtPositions: Array<AdDisplayAt>, selectableCategories: boolean, selectableShops: boolean } };

export type AdsCampaignsQueryVariables = Exact<{
  adsCampaignsInput: AdsCampaignsInput;
  pagination: PaginationInput;
}>;


export type AdsCampaignsQuery = { __typename?: 'RootQueryType', adsCampaigns: { __typename?: 'PaginatedAdsCampaigns', entries: Array<{ __typename?: 'AdsCampaignEntity', id: string, name: string, startAt: any, stopAt: any, targetType: AdTargetType, status: AdsCampaignStatus, languageId: string, customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string } }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AppQueryVariables = Exact<{ [key: string]: never; }>;


export type AppQuery = { __typename?: 'RootQueryType', app: { __typename?: 'AppEntity', name: string, genericProductSource?: { __typename?: 'AppEntity', name: string } | null } };

export type AppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AppConfigQuery = { __typename?: 'RootQueryType', app: { __typename?: 'AppEntity', id: string, geminiTaggingPrompt?: string | null, taggingStrategy?: TaggingStrategy | null } };

export type AppLanguageQueryVariables = Exact<{
  appLanguageInput: AppLanguageInput;
}>;


export type AppLanguageQuery = { __typename?: 'RootQueryType', appLanguage?: { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null };

export type AppLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AppLanguagesQuery = { __typename?: 'RootQueryType', appLanguages?: Array<{ __typename?: 'AppLanguageEntity', id: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null> | null };

export type AppUsersQueryVariables = Exact<{
  appUsers: AppUsersInput;
  pagination: PaginationInput;
}>;


export type AppUsersQuery = { __typename?: 'RootQueryType', appUsers?: { __typename?: 'PaginatedAppUsers', entries: Array<{ __typename?: 'AppUserEntity', id: string, kind: AppUserKind, email: string, firstName?: string | null, lastName?: string | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type BlogAuthorsQueryVariables = Exact<{
  identityUsers: IdentityUsersInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BlogAuthorsQuery = { __typename?: 'RootQueryType', identityUsers?: { __typename?: 'PaginatedIdentityUsers', entries: Array<{ __typename?: 'IdentityUserEntity', firstName?: string | null, lastName?: string | null, id: string }> } | null };

export type BrandQueryVariables = Exact<{
  brandInput: BrandInput;
}>;


export type BrandQuery = { __typename?: 'RootQueryType', brand?: { __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, description?: string | null, position?: number | null, slug: string, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', id: string, name: string }>, syncSource?: { __typename?: 'BrandEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null } | null };

export type BrandsQueryVariables = Exact<{
  brandsInput: BrandsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BrandsQuery = { __typename?: 'RootQueryType', brands?: { __typename?: 'PaginatedBrands', entries: Array<{ __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', name: string }>, syncSource?: { __typename?: 'BrandEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type BrochureQueryQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureQueryQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, language: { __typename?: 'LanguageEntity', id: string } } | null };

export type BrochureCountersQueryVariables = Exact<{
  input: BrochureCountersInput;
}>;


export type BrochureCountersQuery = { __typename?: 'RootQueryType', brochureCounters: Array<{ __typename?: 'BrochureStateCount', state: BrochureState, count: number }> };

export type BrochureLogsQueryVariables = Exact<{
  brochureLogs: BrochureLogsInput;
  pagination: PaginationInput;
}>;


export type BrochureLogsQuery = { __typename?: 'RootQueryType', brochureLogs: { __typename?: 'PaginatedBrochureLogs', entries: Array<{ __typename?: 'AssigneeBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'CreateBrochureLog', createStatus: BrochureCreateStatus, content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'PositionBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'StateBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any }>, pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null } } };

export type BrochureRegionParserQueryVariables = Exact<{
  brochureRegionsInput: BrochureRegionsInput;
}>;


export type BrochureRegionParserQuery = { __typename?: 'RootQueryType', brochureRegions?: Array<{ __typename?: 'BrochureRegionEntity', id: string, parser?: { __typename?: 'ParserEntity', url: string, parserClass: { __typename?: 'ParserClassEntity', moduleName: ParserClasses } } | null, region: { __typename?: 'RegionEntity', id: string } } | null> | null };

export type BrochureShopLangQueryVariables = Exact<{
  brochureId: Scalars['ID']['input'];
}>;


export type BrochureShopLangQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', language: { __typename?: 'LanguageEntity', id: string }, shop: { __typename?: 'ShopEntity', id: string } } | null };

export type BrochureQueryVariables = Exact<{
  brochure: BrochureStatisticsInput;
}>;


export type BrochureQuery = { __typename?: 'RootQueryType', brochureStatistic?: { __typename?: 'BrochureDetailStatiticsEntity', brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null }, interaction: { __typename?: 'InteractionEntryEntity', impressions: number, reach: number, reads: number, readers: number, openingRatio: number, addedToList: number, hotspotClicks: number, hotspotClicksCtr: number, hotspotLinkClicks: number, hotspotLinkClicksCtr: number, clickThroughRate: number, interactionEntries: Array<{ __typename?: 'InteractionMap', category: InteractionCategoryEnum, impressions: number, reads: number } | null> }, pages: Array<{ __typename?: 'PageEntryEntity', index: number, readers: number, reads: number, percentageReadsPageOne: number, averageTimeSeconds: number, totalTimeSeconds: number } | null> } | null };

export type BrochurePagesStatisticsQueryVariables = Exact<{
  brochures: BrochuresPagesStatisticsInput;
}>;


export type BrochurePagesStatisticsQuery = { __typename?: 'RootQueryType', brochuresPagesStatistics?: Array<{ __typename?: 'BrochurePagesStatisticsEntity', averagePageTime: number, averageTimePerReader: number, numberOfPages: number, totalReadTime: number, reads: number, brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null } } | null> | null };

export type BrochureReadsStatisticsQueryVariables = Exact<{
  brochures: BrochuresReadsStatisticsInput;
}>;


export type BrochureReadsStatisticsQuery = { __typename?: 'RootQueryType', brochuresReadsStatistics?: Array<{ __typename?: 'BrochureReadStatisticsEntity', clickThroughRate: number, addedToList: number, hotspotClicks: number, hotspotClicksCtr: number, hotspotLinkClicks: number, hotspotLinkClicksCtr: number, impressions: number, reads: number, brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null } } | null> | null };

export type BrochuresQueryVariables = Exact<{
  brochures: BrochuresStatisticsOverviewInput;
}>;


export type BrochuresQuery = { __typename?: 'RootQueryType', brochuresStatisticsOverview?: { __typename?: 'BrochuresStatisticsOverviewListResponse', id: string, impressions: number, brochureReads: number, pageReads: number, hotspotClicks: number, hotspotLinkClicks: number, statisticsEntries: Array<{ __typename?: 'BrochureStatisticsEntryEntity', brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null }, brochureStatisticsMapsEntity: { __typename?: 'BrochureStatisticsMapsEntity', impressionsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, brochureReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, pageReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotLinkClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null> } } | null>, sumStatisticsEntry: { __typename?: 'BrochureStatisticsMapsEntity', impressionsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, brochureReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, pageReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotLinkClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null> } } | null };

export type CategoriesQueryVariables = Exact<{
  categories?: InputMaybe<CategoriesInput>;
}>;


export type CategoriesQuery = { __typename?: 'RootQueryType', categories?: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null> | null };

export type CategoryQueryVariables = Exact<{
  categoryInput: CategoryInput;
}>;


export type CategoryQuery = { __typename?: 'RootQueryType', category?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type CitiesQueryVariables = Exact<{
  citiesInput: CitiesInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type CitiesQuery = { __typename?: 'RootQueryType', cities?: { __typename?: 'PaginatedCities', entries: Array<{ __typename?: 'CityEntity', id: string, name: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type CityQueryVariables = Exact<{
  cityInput: CityInput;
}>;


export type CityQuery = { __typename?: 'RootQueryType', city?: { __typename?: 'CityEntity', id: string, name: string, position?: number | null } | null };

export type ClientPermissionsQueryVariables = Exact<{
  scope: ClientPermissionsScopeInput;
}>;


export type ClientPermissionsQuery = { __typename?: 'RootQueryType', clientPermissions: Array<CustomerClientPermission> };

export type CustomerClientQueryVariables = Exact<{
  customerClientInput: CustomerClientInput;
}>;


export type CustomerClientQuery = { __typename?: 'RootQueryType', customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string, features: Array<CustomerClientFeature>, identityUsers: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null, email: string } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } };

export type CustomerClientsQueryVariables = Exact<{
  customerClientsInput: CustomerClientsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type CustomerClientsQuery = { __typename?: 'RootQueryType', customerClients: { __typename?: 'PaginatedCustomerClients', entries: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type EnumValuesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EnumValuesQuery = { __typename?: 'RootQueryType', enum?: { __typename?: '__Type', enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null, isDeprecated: boolean }> | null } | null };

export type GenericProductBreadcrumbQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductBreadcrumbQuery = { __typename?: 'RootQueryType', genericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, ancestors: Array<{ __typename?: 'GenericProductCategoryEntity', id: string, name: string }> } | null };

export type GenericProductCategoryBreadcrumbQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenericProductCategoryBreadcrumbQuery = { __typename?: 'RootQueryType', genericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, imageUrl?: string | null, ancestors: Array<{ __typename?: 'GenericProductCategoryEntity', id: string, name: string, imageUrl?: string | null }> } | null };

export type GenericProductCategoryDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductCategoryDetailQuery = { __typename?: 'RootQueryType', genericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type GenericProductDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductDetailQuery = { __typename?: 'RootQueryType', genericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type GenericProductsQueryVariables = Exact<{
  genericProductsArgs: GenericProductsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GenericProductsQuery = { __typename?: 'RootQueryType', genericProducts: Array<{ __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> }> };

export type GenericTreeItemsQueryVariables = Exact<{
  genericTreeItemsInput: GenericTreeItemsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GenericTreeItemsQuery = { __typename?: 'RootQueryType', genericTreeItems: { __typename?: 'PaginatedGenericTreeItems', entries: Array<{ __typename: 'GenericProductCategoryEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> } | { __typename: 'GenericProductEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type HotspotStatisticsQueryVariables = Exact<{
  hotspotsStatistics: HotspotsStatisticsInput;
}>;


export type HotspotStatisticsQuery = { __typename?: 'RootQueryType', hotspotsStatistics: Array<{ __typename?: 'HotspotStatistics', brochureId: string, externalUrl?: string | null, hotspotId: string, linkClicks: number, pageIndex: number, productClicks: number, productLinkClicks: number, productName?: string | null, productTimeSpent: number, productSource?: string | null, timesAddedToList: number, searchImpressions: number, searchProductClicks: number, hotspot?: { __typename: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, fileUrl?: string | null } | null }> };

export type IdentityUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdentityUserQuery = { __typename?: 'RootQueryType', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null };

export type IdentityUsersQueryVariables = Exact<{
  identityUsers: IdentityUsersInput;
  pagination: PaginationInput;
}>;


export type IdentityUsersQuery = { __typename?: 'RootQueryType', identityUsers?: { __typename?: 'PaginatedIdentityUsers', entries: Array<{ __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'RootQueryType', languages?: Array<{ __typename?: 'LanguageEntity', fileUrl?: string | null, id: string, name: string, symbol: string } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'CurrentUser', id: string, firstName?: string | null, lastName?: string | null, roles: Array<string | null>, email: string, fileUrl?: string | null, bio?: string | null } | null };

export type MergeRequestQueryVariables = Exact<{
  mergeRequest: MergeRequestInput;
}>;


export type MergeRequestQuery = { __typename?: 'RootQueryType', mergeRequest?: { __typename?: 'MergeRequestDetails', mergeRequest: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } }, brochureRegions: Array<{ __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> }> } | null };

export type MergeRequestsQueryVariables = Exact<{
  mergeRequests: MergeRequestsInput;
}>;


export type MergeRequestsQuery = { __typename?: 'RootQueryType', mergeRequests: Array<{ __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string, publishedAt?: any | null, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, assignee?: { __typename?: 'IdentityUserEntity', firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus } | null } }> };

export type MyShopiShopBrochuresQueryVariables = Exact<{
  input: MyshopiShopBrochuresInput;
  pagination: PaginationInput;
}>;


export type MyShopiShopBrochuresQuery = { __typename?: 'RootQueryType', myshopiShopBrochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, name: string, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null }> } };

export type OfferCategoriesQueryVariables = Exact<{
  offerCategoriesInput: OfferCategoriesInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type OfferCategoriesQuery = { __typename?: 'RootQueryType', offerCategories?: { __typename?: 'PaginatedOfferCategories', entries: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null, offerCategoryTags: Array<{ __typename?: 'OfferCategoryTagEntity', name: string }>, syncSource?: { __typename?: 'OfferCategoryEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type OfferCategoryQueryVariables = Exact<{
  offerCategoryInput: OfferCategoryInput;
}>;


export type OfferCategoryQuery = { __typename?: 'RootQueryType', offerCategory?: { __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null, position?: number | null, updatedAt?: any | null, syncSource?: { __typename?: 'OfferCategoryEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, fileUrl?: string | null }, offerCategoryTags: Array<{ __typename?: 'OfferCategoryTagEntity', id: string, name: string }>, offerCategoryBlacklistTags: Array<{ __typename?: 'OfferCategoryBlacklistTagEntity', id: string, name: string }>, shopCategories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> } | null };

export type OfferCategoryTagSuggestionsQueryVariables = Exact<{
  input: OfferCategoryTagSuggestionsInput;
}>;


export type OfferCategoryTagSuggestionsQuery = { __typename?: 'RootQueryType', offerCategoryTagSuggestions: Array<{ __typename?: 'OfferCategoryTagEntity', id: string, name: string }> };

export type OfferOcrSuggestionQueryVariables = Exact<{
  hotspot: OfferOcrSuggestionHotspotInput;
  processor: OfferOcrSuggestionProcessor;
}>;


export type OfferOcrSuggestionQuery = { __typename?: 'RootQueryType', offerOcrSuggestion?: { __typename?: 'OfferOcrSuggestion', processor: OfferOcrSuggestionProcessorName, processorResponse?: string | null, offerInputSuggestion?: { __typename?: 'OfferInputSuggestion', name?: string | null, description?: string | null, priceBeforeDiscount?: number | null, discountPercent?: number | null, priceAfterDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string }> } | null, croppedBlocks: Array<{ __typename?: 'VisionBlock', confidence?: number | null, paragraphs: Array<{ __typename?: 'VisionParagraph', confidence?: number | null, text: string, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string }> }> }> } | null };

export type PagesWithHotspotsQueryVariables = Exact<{
  brochureRegionId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;


export type PagesWithHotspotsQuery = { __typename?: 'RootQueryType', pagesWithHotspots: { __typename?: 'PaginatedPagesWithHotspots', entries: Array<{ __typename?: 'PageEntity', id: string, index: number, fileUrl?: string | null, hotspots?: Array<{ __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } }> | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type PagesWithHotspotsUrlsQueryVariables = Exact<{
  brochureRegionId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;


export type PagesWithHotspotsUrlsQuery = { __typename?: 'RootQueryType', pagesWithHotspots: { __typename?: 'PaginatedPagesWithHotspots', entries: Array<{ __typename?: 'PageEntity', index: number, hotspots?: Array<{ __typename?: 'HotspotImageEntity', url?: string | null } | { __typename?: 'HotspotLinkEntity', url?: string | null } | { __typename?: 'HotspotProductEntity', url?: string | null }> | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type ParserClassByUrlQueryVariables = Exact<{
  parserClassByUrl: ParserClassByUrlInput;
}>;


export type ParserClassByUrlQuery = { __typename?: 'RootQueryType', parserClassByUrl?: ParserClasses | null };

export type ParserParametersQueryVariables = Exact<{
  parserParameters: ParserParametersInput;
}>;


export type ParserParametersQuery = { __typename?: 'RootQueryType', parserParameters: { __typename?: 'ParserParameters', parserClass?: ParserClasses | null, parsers: Array<{ __typename?: 'CreateBrochureRegionParams', url?: string | null, region: { __typename?: 'RegionEntity', id: string } }> } };

export type PostProcessingStatusQueryVariables = Exact<{
  postProcessingStatus: PostProcessingStatusInput;
}>;


export type PostProcessingStatusQuery = { __typename?: 'RootQueryType', postProcessingStatus: PostProcessingStatus };

export type PublicBrochuresQueryVariables = Exact<{
  input: PublicBrochuresInput;
  pagination: PaginationInput;
  cityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicBrochuresQuery = { __typename?: 'RootQueryType', publicBrochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, position?: number | null, positionFrozenTo?: any | null, name: string, publishedAt?: any | null, activeFrom?: any | null, expireAfter?: any | null, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, brochureCity?: { __typename?: 'BrochureCityEntity', position: number } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null } } };

export type RegionsQueryVariables = Exact<{
  regions: RegionsInput;
}>;


export type RegionsQuery = { __typename?: 'RootQueryType', regions: Array<{ __typename: 'RegionEntity', id: string, name: string, locationsCount: number }> };

export type SessionsQueryVariables = Exact<{
  input: SessionsInput;
}>;


export type SessionsQuery = { __typename?: 'RootQueryType', sessions: Array<{ __typename?: 'SessionStatistic', totalSessionTime: number, trackedAt: any }> };

export type ShopQueryVariables = Exact<{
  shop: ShopInput;
}>;


export type ShopQuery = { __typename?: 'RootQueryType', shop?: { __typename?: 'ShopEntity', id: string, name: string, fileUrl?: string | null } | null };

export type ShopCardTemplateQueryVariables = Exact<{
  input: ShopCardTemplateInput;
}>;


export type ShopCardTemplateQuery = { __typename?: 'RootQueryType', shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> } | null };

export type ShopCardTemplatesQueryVariables = Exact<{
  input: ShopCardTemplatesInput;
  pagination: PaginationInput;
}>;


export type ShopCardTemplatesQuery = { __typename?: 'RootQueryType', shopCardTemplates: { __typename?: 'PaginatedShopCardTemplates', entries: Array<{ __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type LocationQueryVariables = Exact<{
  location: LocationInput;
}>;


export type LocationQuery = { __typename?: 'RootQueryType', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null };

export type ShopsQueryVariables = Exact<{
  shops: ShopsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ShopsQuery = { __typename?: 'RootQueryType', shops?: { __typename?: 'PaginatedShops', entries: Array<{ __typename?: 'ShopEntity', id: string, name: string, fileUrl?: string | null, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null }> } | null };

export type TagStatisticsQueryVariables = Exact<{
  tagStatisticsInput: TagStatisticsInput;
}>;


export type TagStatisticsQuery = { __typename?: 'RootQueryType', tagStatistics: Array<{ __typename?: 'TagStatistic', totalTagged: number, taggedAt: any }> };

export type TagStatisticsOverviewQueryVariables = Exact<{
  tagStatisticsOverviewInput: TagStatisticsOverviewInput;
}>;


export type TagStatisticsOverviewQuery = { __typename?: 'RootQueryType', tagStatisticsOverview: { __typename?: 'TagStatisticsOverview', tagStatisticsPerHotspot?: number | null, totalSessionTime: number, userTagStatistics: Array<{ __typename?: 'UserTagStatistic', totalTagged: number, fullName: string, totalSessionTime: number }> } };

export type TaggingUsersQueryVariables = Exact<{
  taggingUsersInput: TaggingUsersInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TaggingUsersQuery = { __typename?: 'RootQueryType', taggingUsers?: { __typename?: 'PaginatedIdentityUsers', pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null }, entries: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null }> } | null };

export type WebsitePageQueryQueryVariables = Exact<{
  websitePage: WebsitePageInput;
}>;


export type WebsitePageQueryQuery = { __typename?: 'RootQueryType', websitePage?: { __typename?: 'WebsitePagePage', positionInFooter?: number | null, contentBlocks: Array<string>, titleQuestionsAnswers?: string | null, id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, contentQuestionsAnswers: Array<{ __typename?: 'WebsitePageQuestionAnswer', question: string, answer: string }>, language: { __typename?: 'LanguageEntity', id: string } } | { __typename?: 'WebsitePagePost', coverImage?: string | null, publishedAt?: any | null, id: string, content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null, user?: { __typename?: 'IdentityUserEntity', id: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, language: { __typename?: 'LanguageEntity', id: string } } | null };

export type WebsitePagesQueryQueryVariables = Exact<{
  websitePages: WebsitePagesInput;
  pagination: PaginationInput;
}>;


export type WebsitePagesQueryQuery = { __typename?: 'RootQueryType', websitePages?: { __typename?: 'PaginatedWebsitePages', entries: Array<{ __typename?: 'WebsitePagePage', positionInFooter?: number | null, id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | { __typename?: 'WebsitePagePost', id: string, content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type LocationImportedSubscriptionVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type LocationImportedSubscription = { __typename?: 'RootSubscriptionType', locationImported: { __typename?: 'ImportedLocationEntity', address: string, city: string, name: string, regionId: string, zipCode: string, shopId: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null } };

export type PdfMessageAddedSubscriptionVariables = Exact<{
  pdfId: Scalars['ID']['input'];
}>;


export type PdfMessageAddedSubscription = { __typename?: 'RootSubscriptionType', pdfMessageAdded: { __typename?: 'PdfMessageEntity', coverUrl?: string | null, indexUrl?: string | null, message: string, pdfId: string } };

export type BrochureLogAddedSubscriptionVariables = Exact<{
  brochureId: Scalars['ID']['input'];
}>;


export type BrochureLogAddedSubscription = { __typename?: 'RootSubscriptionType', brochureLogAdded: { __typename?: 'AssigneeBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'CreateBrochureLog', createStatus: BrochureCreateStatus, content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'PositionBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'StateBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } };
